import * as i0 from '@angular/core';
import { Component, Input, Directive, HostListener, EventEmitter, Output, ViewEncapsulation, InjectionToken, Injectable, Inject, ChangeDetectionStrategy, ViewChild, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@segurosvoluntarios_vel/commons-services';
import { MensajesConstantesService, ErrorManage, LimitNumber } from '@segurosvoluntarios_vel/commons-services';
import { Subscription, Subject, merge } from 'rxjs';
import * as i3 from '@angular/forms';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule, Validators } from '@angular/forms';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$2 from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerI18n, NgbDateParserFormatter, NgbDatepickerModule, NgbTypeaheadModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import * as i1$3 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as i4 from 'ng-recaptcha';
import { RecaptchaModule } from 'ng-recaptcha';
import * as i3$1 from '@segurosvoluntarios_vel/lib-angular-components/src/sura-modal';
import { SuraModalModule } from '@segurosvoluntarios_vel/lib-angular-components/src/sura-modal';

// Angular Core
class PaginaErrorComponent {
    constructor() {
        this.message = '';
        this.idProducto = '';
    }
}
PaginaErrorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaginaErrorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PaginaErrorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PaginaErrorComponent, selector: "lib-pagina-error", inputs: { message: "message", idProducto: "idProducto" }, ngImport: i0, template: "<div class=\"text-center\">\n  <h1>{{ idProducto }}</h1>\n  <br />\n  <h2>Los sentimos, no podemos gestionar tu seguro en l\u00EDnea.</h2>\n  <p>{{ message }}</p>\n  <br />\n</div>\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaginaErrorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-pagina-error',
                    templateUrl: './pagina-error.component.html',
                    styleUrls: ['./pagina-error.component.scss'],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { message: [{
                type: Input
            }], idProducto: [{
                type: Input
            }] } });

class PaginaNoEncontradaComponent {
    constructor() {
        if (this.tenant === 'exitoatendido') {
            window.location.href = this.url;
        }
    }
}
PaginaNoEncontradaComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaginaNoEncontradaComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PaginaNoEncontradaComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PaginaNoEncontradaComponent, selector: "lib-pagina-no-encontrada", inputs: { url: "url", firstImg: "firstImg", secondImg: "secondImg", tenant: "tenant" }, ngImport: i0, template: "<div\n  class=\"container d-flex justify-content-center align-items-center min-height-vh text-center page-404-not-found\"\n>\n  <div>\n    <img src=\"{{ firstImg }}\" alt=\"Image ups\" />\n    <img src=\"{{ secondImg }}\" alt=\"Image personaje\" />\n    <h3 class=\"page-404-not-found__title\">\n      \u00A1Hemos realizado una b\u00FAsqueda completa!\n    </h3>\n    <p class=\"text margin-bottom\">Sin embargo, esta p\u00E1gina ya no existe.</p>\n    <p class=\"text\">\n      Visita nuestra p\u00E1gina de <a href=\"{{ url }}\">inicio</a> o inf\u00F3rmanos este\n      error 404 <span class=\"clr\"></span> en servicio de atenci\u00F3n al cliente\n      marcando desde tu celular al <strong>#888.</strong>\n    </p>\n  </div>\n</div>\n", styles: [".page-404-not-found img{max-width:100%}.page-404-not-found__title{font-size:26px;color:#0033a0;font-weight:bold}.page-404-not-found .text{margin:0}.page-404-not-found .text a{color:#0033a0;text-decoration:underline}.page-404-not-found .text strong{font-size:18px;color:#0033a0}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaginaNoEncontradaComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-pagina-no-encontrada',
                    templateUrl: './pagina-no-encontrada.component.html',
                    styleUrls: ['./pagina-no-encontrada.component.scss'],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { url: [{
                type: Input
            }], firstImg: [{
                type: Input
            }], secondImg: [{
                type: Input
            }], tenant: [{
                type: Input
            }] } });

const DEFAULT_ASESOR = {
    codigo: '4999',
    nombre: 'SEGUROS GENERALES SURAMERICANA S.A.',
    nombreCodigo: 'SEGUROS GENERALES SURAMERICANA S.A. (4999)',
    codigoOficina: '248',
    correo: 'contactenos@suramericana.com.co',
};

class LimitNumberDirective {
    handleKeyboardEvent(event) {
        if (this.appLimitNumberDirective) {
            const limitTo = this.appLimitNumberDirective;
            if (limitTo * 1 === event.target.value.length) {
                event.preventDefault();
            }
        }
    }
}
LimitNumberDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LimitNumberDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
LimitNumberDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: LimitNumberDirective, selector: "[appLimitNumberDirective]", inputs: { appLimitNumberDirective: "appLimitNumberDirective" }, host: { listeners: { "keypress": "handleKeyboardEvent($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LimitNumberDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appLimitNumberDirective]',
                }]
        }], propDecorators: { appLimitNumberDirective: [{
                type: Input
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['keypress', ['$event']]
            }] } });

class AsesoresComponent {
    constructor(asesoresService) {
        this.asesoresService = asesoresService;
        this.observableAsesoresEmit = 0;
        this.hasSwitch = true;
        this.disabled = false;
        this.isSuraTenant = true;
        this.maxItemsToShow = 10;
        this.wasValidate = false;
        this.maxCharactersCode = 6;
        this.isUrlPersonalizada = false;
        this.subscription = new Subscription();
        this.changeAsesor = new EventEmitter();
        this.activeChange = new EventEmitter();
    }
    ngOnInit() {
        if (this.form.value) {
            this.asesoresService.fetchAsesor(this.form.value);
        }
        this.subscription.add(this.subscribeToLoadAsesores());
        this.subscription.add(this.subscribeToFormChanges());
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    mostrarMensajeError(error) {
        return MensajesConstantesService.getConstante(Object.keys(error)[0].toUpperCase());
    }
    onInputChange(codigo) {
        if (/^[a-zA-Z0-9\s]+$/.test(codigo)) {
            this.asesoresService.fetchAsesor(codigo);
        }
    }
    toggleActive() {
        if (!this.disabled) {
            this.active = !this.active;
            this.form.setValue(null);
            this.activeChange.emit(this.active);
        }
    }
    get asesorSelected() {
        return this.asesor;
    }
    subscribeToLoadAsesores() {
        return this.asesoresService.getAsesor().subscribe(asesores => {
            this.observableAsesoresEmit++;
            this.asesores = asesores;
            // Esto se hace debido a que el primer valor emitido es un array vacío [] por lo cuál no se puede validar la información hasta el segundo valor emitido que surge después de que se haya hecho el request, por ende si el segundo valor emitido también es un array vacío [] se entiende que el código de asesor no es válido
            if (this.observableAsesoresEmit === 2 && !this.asesores.length) {
                this.asesor = DEFAULT_ASESOR;
                this.form.setValue(DEFAULT_ASESOR.codigo);
                this.onInputChange(DEFAULT_ASESOR.codigo);
                return;
            }
            if (!this.asesores || !this.asesores.length)
                return;
            const items = this.asesores.map((asesor) => ({
                name: asesor.nombreCodigo,
                value: asesor.codigo,
            }));
            this.itemsParsed = JSON.stringify(items) || '';
            if (this.asesores.length === 1 ||
                this.disabled ||
                this.isUrlPersonalizada) {
                this.selectAsesor();
                return;
            }
            this.form.setErrors({ CODIGO_ASESOR_INVALIDA: true });
        });
    }
    selectAsesor() {
        const asesorFinded = this.asesores.find(asesor => asesor.codigo === this.form.value);
        if (asesorFinded) {
            this.form.setValue(asesorFinded.codigo);
            this.asesor = asesorFinded;
        }
        if (!asesorFinded && this.asesores.length) {
            this.asesor = DEFAULT_ASESOR;
            this.form.setValue(DEFAULT_ASESOR.codigo);
        }
    }
    subscribeToFormChanges() {
        return this.form.valueChanges.subscribe((value) => {
            var _a;
            if (value) {
                this.asesor =
                    ((_a = this.asesor) === null || _a === void 0 ? void 0 : _a.codigo) === '4999' && value === '4999'
                        ? this.asesor
                        : this.asesores.find(asesor => asesor.codigo === value);
            }
            else {
                this.asesor = null;
            }
            this.changeAsesor.emit(this.asesor);
        });
    }
}
AsesoresComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AsesoresComponent, deps: [{ token: i1.SuraAsesoresService }], target: i0.ɵɵFactoryTarget.Component });
AsesoresComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AsesoresComponent, selector: "lib-asesores", inputs: { active: "active", form: "form", hasSwitch: "hasSwitch", disabled: "disabled", isSuraTenant: "isSuraTenant", maxItemsToShow: "maxItemsToShow", wasValidate: "wasValidate", maxCharactersCode: "maxCharactersCode", isUrlPersonalizada: "isUrlPersonalizada" }, outputs: { changeAsesor: "changeAsesor", activeChange: "activeChange" }, ngImport: i0, template: "<div class=\"container-lib-asesores\">\n  <div class=\"d-flex align-items-center\">\n    <div class=\"my-2 col-10 col-md-9 col-lg-10 px-0\">\n      <ng-content></ng-content>\n    </div>\n    <div *ngIf=\"hasSwitch\" class=\"col-2 col-md-3 col-lg-2 px-0\">\n      <sura-switch\n        (click)=\"toggleActive()\"\n        [active]=\"active\"\n        showstatus=\"true\"\n      ></sura-switch>\n    </div>\n  </div>\n  <input-typeahead\n    *ngIf=\"(active || !hasSwitch) && isSuraTenant\"\n    [items]=\"itemsParsed\"\n    [maxitemstoshow]=\"maxItemsToShow\"\n    (inputchange)=\"onInputChange($event.detail)\"\n    [formControl]=\"form\"\n    [wasvalidate]=\"wasValidate\"\n    [internalId]=\"'id-codigo-asesor-sura'\"\n    ngDefaultControl\n    [validateErrors]\n  >\n  </input-typeahead>\n  <div class=\"text-danger\" *ngIf=\"isSuraTenant && form.errors\">\n    {{ mostrarMensajeError(form.errors) }}\n  </div>\n  <input-material-design\n    *ngIf=\"(active || !hasSwitch) && !isSuraTenant\"\n    label=\"Codigo Asesor\"\n    [formControl]=\"form\"\n    type=\"number\"\n    errorposition=\"left\"\n    id=\"id-codigo-asesor\"\n    ngDefaultControl\n    [wasvalidate]=\"wasValidate\"\n    [validateErrors]\n    [appLimitNumberDirective]=\"maxCharactersCode\"\n  ></input-material-design>\n</div>\n", styles: [".container-lib-asesores{display:flex;flex-direction:column}\n"], directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i1.ErrorManageDirective, selector: "[validateErrors]", inputs: ["inputTextErrorControl", "formStatus", "wasvalidate"] }, { type: i1.LimitNumberDirective, selector: "[appLimitNumberDirective]", inputs: ["appLimitNumberDirective"] }, { type: LimitNumberDirective, selector: "[appLimitNumberDirective]", inputs: ["appLimitNumberDirective"] }], viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AsesoresComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-asesores',
                    templateUrl: './asesores.component.html',
                    styleUrls: ['./asesores.component.scss'],
                    viewProviders: [
                        { provide: ControlContainer, useExisting: FormGroupDirective },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i1.SuraAsesoresService }]; }, propDecorators: { active: [{
                type: Input
            }], form: [{
                type: Input
            }], hasSwitch: [{
                type: Input
            }], disabled: [{
                type: Input
            }], isSuraTenant: [{
                type: Input
            }], maxItemsToShow: [{
                type: Input
            }], wasValidate: [{
                type: Input
            }], maxCharactersCode: [{
                type: Input
            }], isUrlPersonalizada: [{
                type: Input
            }], changeAsesor: [{
                type: Output
            }], activeChange: [{
                type: Output
            }] } });

// Angular Core
class SuraButtonComponent {
    constructor() {
        this.variant = 'primary';
        this.size = 'lg';
        this.buttonType = 'button';
        this.disabled = false;
        // tslint:disable-next-line:no-output-on-prefix
        this.onClick = new EventEmitter();
    }
    handleClick() {
        this.onClick.emit();
    }
    getClassName(className, hover) {
        if (hover) {
            return `sura-lib-button_${className}-${hover}`;
        }
        return `sura-lib-button_${className}`;
    }
}
SuraButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SuraButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SuraButtonComponent, selector: "lib-sura-button", inputs: { variant: "variant", size: "size", buttonType: "buttonType", styles: "styles", selfLink: "selfLink", hover: "hover", disabled: "disabled" }, outputs: { onClick: "onClick" }, ngImport: i0, template: "<button\n  [type]=\"buttonType\"\n  class=\"sura-lib-px-5 sura-lib-py-1 sura-lib-button\"\n  [ngClass]=\"[getClassName(variant), getClassName(variant, hover)]\"\n  [ngStyle]=\"styles\"\n  [disabled]=\"disabled\"\n  (click)=\"handleClick()\"\n  [routerLink]=\"selfLink\"\n>\n  <ng-content></ng-content>\n</button>\n", styles: [".sura-lib-button{border:0;font-size:1rem;outline:0;border-radius:50px;transition:all .15s ease-in-out;cursor:pointer;font-size:1.25rem;display:block;margin:0 auto;box-shadow:0 3px 3px #00000029}.sura-lib-button_primary{background-color:#00aec7;color:#fff}.sura-lib-button_primary-primary{transition:all .15s ease-in-out}.sura-lib-button_primary-primary:hover{background-color:#e3e829!important;color:#0033a0!important}.sura-lib-button_secondary{background-color:#e3e829;color:#0033a0}\n"], directives: [{ type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i2.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["routerLink", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-sura-button',
                    templateUrl: './sura-button.component.html',
                    styleUrls: ['./sura-button.component.scss'],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { variant: [{
                type: Input
            }], size: [{
                type: Input
            }], buttonType: [{
                type: Input
            }], styles: [{
                type: Input
            }], selfLink: [{
                type: Input
            }], hover: [{
                type: Input
            }], disabled: [{
                type: Input
            }], onClick: [{
                type: Output
            }] } });

class ConfirmationModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
        this.html = false;
        this.footerButtonCotizar = {
            'font-family': 'FSJoeyBold',
            'font-size': '1.25rem',
        };
    }
    ngOnInit() { }
    accept() {
        this.activeModal.close(true);
    }
    cancel() {
        this.activeModal.close(false);
    }
}
ConfirmationModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfirmationModalComponent, deps: [{ token: i1$2.NgbActiveModal }], target: i0.ɵɵFactoryTarget.Component });
ConfirmationModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ConfirmationModalComponent, selector: "lib-confirmation-modal", inputs: { message: "message", title: "title", html: "html", yesLabel: "yesLabel", noLabel: "noLabel", typeModal: "typeModal", buttonOkTemplate: "buttonOkTemplate", buttonCancelTemplate: "buttonCancelTemplate" }, ngImport: i0, template: "<div\n  class=\"modal-header px-4 border-0\"\n  *ngIf=\"typeModal !== 'messageWithConfirmation'\"\n>\n  <h5 class=\"modal-title\" *ngIf=\"title\">{{ title }}</h5>\n  <button\n    type=\"button\"\n    class=\"close close-modal\"\n    data-dismiss=\"modal\"\n    aria-label=\"Close\"\n    (click)=\"cancel()\"\n  >\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div\n  *ngIf=\"!html\"\n  class=\"modal-body\"\n  [ngClass]=\"{\n    'message-with-confirmation': typeModal === 'messageWithConfirmation'\n  }\"\n>\n  <p>{{ message }}</p>\n</div>\n<div *ngIf=\"html\" class=\"modal-body px-4\">\n  <ng-container *ngTemplateOutlet=\"message\"></ng-container>\n</div>\n<div *ngIf=\"typeModal === 'confirmation'\" class=\"modal-footer border-0\">\n  <ng-container *ngIf=\"!buttonOkTemplate || !buttonCancelTemplate\">\n    <button\n      ngbAutofocus\n      type=\"button\"\n      class=\"type-modal-message type-modal-message__cancel\"\n      data-dismiss=\"modal\"\n      (click)=\"cancel()\"\n    >\n      {{ noLabel }}\n    </button>\n    <button (click)=\"accept()\" type=\"button\" class=\"type-modal-message\">\n      {{ yesLabel }}\n    </button>\n  </ng-container>\n  <div *ngIf=\"buttonOkTemplate && buttonCancelTemplate\" class=\"row\">\n    <div class=\"col-6\">\n      <div class=\"w-100\" (click)=\"cancel()\">\n        <ng-container\n          data-dismiss=\"modal\"\n          *ngTemplateOutlet=\"buttonCancelTemplate\"\n        ></ng-container>\n      </div>\n    </div>\n    <div class=\"col-6\">\n      <div class=\"w-100\" (click)=\"accept()\">\n        <ng-container\n          data-dismiss=\"modal\"\n          *ngTemplateOutlet=\"buttonOkTemplate\"\n        ></ng-container>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div *ngIf=\"typeModal === 'message'\" class=\"modal-footer border-0\">\n  <button\n    *ngIf=\"!buttonOkTemplate\"\n    ngbAutofocus\n    type=\"button\"\n    class=\"type-modal-message\"\n    data-dismiss=\"modal\"\n    (click)=\"accept()\"\n  >\n    {{ yesLabel }}\n  </button>\n\n  <div class=\"w-100\" *ngIf=\"buttonOkTemplate\" (click)=\"accept()\">\n    <ng-container\n      data-dismiss=\"modal\"\n      *ngTemplateOutlet=\"buttonOkTemplate\"\n    ></ng-container>\n  </div>\n</div>\n<div\n  *ngIf=\"typeModal === 'messageWithConfirmation'\"\n  class=\"justify-content-center modal-footer border-0\"\n>\n  <lib-sura-button\n    *ngIf=\"!buttonOkTemplate\"\n    data-dismiss=\"modal\"\n    (click)=\"accept()\"\n    variant=\"secondary\"\n    [styles]=\"footerButtonCotizar\"\n  >\n    {{ yesLabel }}\n  </lib-sura-button>\n  <div class=\"w-100\" *ngIf=\"buttonOkTemplate\" (click)=\"accept()\">\n    <ng-container\n      data-dismiss=\"modal\"\n      *ngTemplateOutlet=\"buttonOkTemplate\"\n    ></ng-container>\n  </div>\n</div>\n", styles: [".modal-title{font-size:1.625rem;color:#333;font-weight:bold}.close-modal{position:absolute;right:1rem;outline:none;opacity:1;font-size:1.8rem;padding:.8rem 1rem}.close-modal:not(:disabled):not(.disabled):focus,.close-modal:not(:disabled):not(.disabled):hover{opacity:1;outline:none}.type-modal-message{background-color:#fff;border:0;outline:none;color:#00aec7;font-size:1rem;font-weight:bolder;font-weight:bold}.type-modal-message:focus,.type-modal-message:hover{outline:none}.type-modal-message__cancel{color:#333}.modal-footer{border-top:0!important}.modal-footer button{text-transform:uppercase;font-size:14px}.mw-650 .modal-dialog{max-width:650px}.message-with-confirmation{text-align:center;font-size:1.875rem}.message-with-confirmation p{line-height:1;margin:0}.modal-body{padding:1rem 1.5rem}.modal-body p{color:#999;font-size:14px;font-weight:300}.mh-250{display:flex!important;align-items:center;justify-content:center}.mh-250 .modal-content{min-height:250px;display:flex;align-items:center;justify-content:center}\n"], components: [{ type: SuraButtonComponent, selector: "lib-sura-button", inputs: ["variant", "size", "buttonType", "styles", "selfLink", "hover", "disabled"], outputs: ["onClick"] }], directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfirmationModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-confirmation-modal',
                    templateUrl: './confirmation-modal.component.html',
                    styleUrls: ['./confirmation-modal.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }]; }, propDecorators: { message: [{
                type: Input
            }], title: [{
                type: Input
            }], html: [{
                type: Input
            }], yesLabel: [{
                type: Input
            }], noLabel: [{
                type: Input
            }], typeModal: [{
                type: Input
            }], buttonOkTemplate: [{
                type: Input
            }], buttonCancelTemplate: [{
                type: Input
            }] } });

class ChatbotTibotComponent {
}
ChatbotTibotComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChatbotTibotComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ChatbotTibotComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ChatbotTibotComponent, selector: "lib-chatbot-tibot", inputs: { show: "show", urlIcon: "urlIcon" }, ngImport: i0, template: "<a\n  id=\"chatIcon\"\n  href=\"javascript:\"\n  class=\"tibot-chat\"\n  [style.visibility]=\"show ? 'visible' : 'hidden'\"\n>\n  <img [src]=\"urlIcon\" alt=\"Logo Tibot\" class=\"openchat\" />\n  <div class=\"tibot-chat__text openchat\">Chatea con <strong>TiBot</strong></div>\n  <div id=\"notification\" class=\"chatbot-pratech-floating-badge\">\n    <label id=\"countNotification\"></label>\n  </div>\n</a>\n", styles: [".tibot-chat{align-items:center;background-color:#0033a0;border-radius:35px 35px 0;bottom:75px;box-shadow:0 0 15px #000;box-sizing:initial;display:flex;height:53px;justify-content:center;position:fixed;right:10px;width:53px;z-index:999}.tibot-chat img{height:35px;right:2px;width:35px}@media (min-width: 992px){.tibot-chat{bottom:30px;height:auto;padding:10px 15px;right:30px;width:100px}}.tibot-chat__text{color:#fff;display:none}@media (min-width: 992px){.tibot-chat__text{display:block;font-size:.75rem}}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChatbotTibotComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-chatbot-tibot',
                    templateUrl: './chatbot-tibot.component.html',
                    styleUrls: ['./chatbot-tibot.component.scss'],
                }]
        }], propDecorators: { show: [{
                type: Input
            }], urlIcon: [{
                type: Input
            }] } });

const ERROR_MESSAGES = new InjectionToken('ERROR_MESSAGES');

class SuraFormService {
    constructor(errorMessages) {
        this.errorMessages = errorMessages;
    }
    getErrorMessage(key) {
        const findErrorMessage = this.errorMessages.find(errorMessage => {
            return errorMessage.key === key.toUpperCase();
        });
        return findErrorMessage
            ? findErrorMessage.errorMessage
            : SuraFormService.DEFAULT_MESSAGE;
    }
}
SuraFormService.DEFAULT_MESSAGE = 'Campo inválido';
SuraFormService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormService, deps: [{ token: ERROR_MESSAGES }], target: i0.ɵɵFactoryTarget.Injectable });
SuraFormService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ERROR_MESSAGES]
                }] }]; } });

var InputProperty;
(function (InputProperty) {
    InputProperty["ID"] = "id";
})(InputProperty || (InputProperty = {}));

class BaseInput {
    constructor() {
        this.handleChange = new EventEmitter();
        this.handleBlur = new EventEmitter();
        this.handleKeyDown = new EventEmitter();
        this.handleKeyUp = new EventEmitter();
        this.subscription = new Subscription();
    }
    ngOnInit() {
        this.componentValidatorService.checkRequiredFields(this.id, InputProperty.ID);
        this.subscribeToMarkForCheck();
    }
    subscribeToMarkForCheck() {
        this.subscription.add(this.control.valueChanges.subscribe(() => {
            this.changeDetectorRef.markForCheck();
        }));
    }
    onChange(event) {
        this.handleChange.emit(event.target.value);
    }
    onBlur(event) {
        this.handleBlur.emit(event.target.value);
    }
    showErrorMessage(key) {
        return this.suraFormService.getErrorMessage(Object.keys(key)[0]);
    }
    checkControl() {
        return this.componentValidatorService.wasValidate(this.control, this.wasValidate);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
BaseInput.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BaseInput, deps: [], target: i0.ɵɵFactoryTarget.Directive });
BaseInput.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: BaseInput, inputs: { control: "control", wasValidate: "wasValidate", id: "id", textTransform: "textTransform", disabled: "disabled", alignCenter: "alignCenter" }, outputs: { handleChange: "handleChange", handleBlur: "handleBlur", handleKeyDown: "handleKeyDown", handleKeyUp: "handleKeyUp" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BaseInput, decorators: [{
            type: Directive
        }], propDecorators: { control: [{
                type: Input
            }], wasValidate: [{
                type: Input
            }], id: [{
                type: Input
            }], textTransform: [{
                type: Input
            }], disabled: [{
                type: Input
            }], alignCenter: [{
                type: Input
            }], handleChange: [{
                type: Output
            }], handleBlur: [{
                type: Output
            }], handleKeyDown: [{
                type: Output
            }], handleKeyUp: [{
                type: Output
            }] } });

class ComponentValidatorService {
    checkRequiredFields(input, error) {
        if (!input) {
            throw new Error(`Attribute ${error} is required`);
        }
    }
    wasValidate(control, wasValidate) {
        return ((!control.valid && control.touched && !control.disabled) ||
            (control.untouched && wasValidate && !control.disabled));
    }
}
ComponentValidatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ComponentValidatorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ComponentValidatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ComponentValidatorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ComponentValidatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class TolowercaseDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    onInputChange() {
        if (this.elementTolowercase) {
            this.elementRef.nativeElement.value = this.elementRef.nativeElement.value.toLowerCase();
        }
    }
}
TolowercaseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TolowercaseDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
TolowercaseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TolowercaseDirective, selector: "[libTolowercase]", inputs: { elementTolowercase: ["libTolowercase", "elementTolowercase"] }, host: { listeners: { "input": "onInputChange()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TolowercaseDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[libTolowercase]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { elementTolowercase: [{
                type: Input,
                args: ['libTolowercase']
            }], onInputChange: [{
                type: HostListener,
                args: ['input']
            }] } });

// Angular Core
class DisableCopyPasteDirective {
    constructor() { }
    blockPaste(e) {
        if (this.appDisableCopyPaste) {
            e.preventDefault();
        }
    }
    blockCopy(e) {
        if (this.appDisableCopyPaste) {
            e.preventDefault();
        }
    }
    blockCut(e) {
        if (this.appDisableCopyPaste) {
            e.preventDefault();
        }
    }
}
DisableCopyPasteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DisableCopyPasteDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
DisableCopyPasteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: DisableCopyPasteDirective, selector: "[appDisableCopyPaste]", inputs: { appDisableCopyPaste: "appDisableCopyPaste" }, host: { listeners: { "paste": "blockPaste($event)", "copy": "blockCopy($event)", "cut": "blockCut($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DisableCopyPasteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appDisableCopyPaste]',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { appDisableCopyPaste: [{
                type: Input,
                args: ['appDisableCopyPaste']
            }], blockPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }], blockCopy: [{
                type: HostListener,
                args: ['copy', ['$event']]
            }], blockCut: [{
                type: HostListener,
                args: ['cut', ['$event']]
            }] } });

class LibInputMaterialDesignComponent extends BaseInput {
    constructor(suraFormService, componentValidatorService, changeDetectorRef) {
        super();
        this.suraFormService = suraFormService;
        this.componentValidatorService = componentValidatorService;
        this.changeDetectorRef = changeDetectorRef;
        this.inputType = 'text';
        this.handleChange = new EventEmitter();
    }
    handleOnKeyDown(event) {
        if (this.inputType === 'number' && event.key === 'e') {
            event.preventDefault();
        }
        this.handleKeyDown.emit(event.target.value);
    }
    handleOnKeyUp(event) {
        this.handleKeyUp.emit(event.target.value);
    }
}
LibInputMaterialDesignComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibInputMaterialDesignComponent, deps: [{ token: SuraFormService }, { token: ComponentValidatorService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
LibInputMaterialDesignComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibInputMaterialDesignComponent, selector: "lib-input-material-design", inputs: { label: "label", maxlength: "maxlength", minlength: "minlength", inputType: "inputType", enableCopyPaste: "enableCopyPaste", enableTolowercase: "enableTolowercase", numberMaxlength: "numberMaxlength" }, outputs: { handleChange: "handleChange" }, usesInheritance: true, ngImport: i0, template: "<div class=\"mb-3 position-relative\" [class.was-validate]=\"checkControl()\">\n  <div\n    class=\"d-flex align-items-center form-material position-relative\"\n    [class.justify-content-center]=\"alignCenter\"\n  >\n    <ng-content select=\"[slot=inputRef]\"></ng-content>\n    <input\n      [formControl]=\"control\"\n      [type]=\"inputType\"\n      class=\"py-2 px-3 form-material__input\"\n      [class.ng-not-empty]=\"control.value\"\n      autocomplete=\"off\"\n      [minlength]=\"minlength\"\n      [maxlength]=\"maxlength\"\n      [id]=\"id\"\n      (blur)=\"onBlur($event)\"\n      (change)=\"onChange($event)\"\n      [libTolowercase]=\"enableTolowercase\"\n      [style.text-transform]=\"textTransform\"\n      [appDisableCopyPaste]=\"enableCopyPaste\"\n      [appLimitNumberDirective]=\"numberMaxlength\"\n      (keydown)=\"handleOnKeyDown($event)\"\n      (keyup)=\"handleOnKeyUp($event)\"\n    />\n    <label class=\"mx-2 px-2 mb-0 form-material__label\" *ngIf=\"label\">{{\n      label\n    }}</label>\n    <i\n      class=\"fal fa-check form-material__icon-state form-material__icon-state_success\"\n    ></i>\n    <i\n      class=\"fal fa-times form-material__icon-state form-material__icon-state_error\"\n    ></i>\n  </div>\n  <div\n    class=\"invalid-message\"\n    [class.text-center]=\"alignCenter\"\n    *ngIf=\"control.errors\"\n  >\n    {{ showErrorMessage(control.errors) }}\n  </div>\n</div>\n", styles: ["", ".form-material{margin-bottom:1.7rem}.form-material__input{width:100%;background:#fff;border:.0625rem solid var(--form-material-input-border-color, #d2d2d2);outline:none;color:#000;font-size:1rem;border-radius:.25rem;font-family:var(--font-family-form-material, var(--font-family-secondary));box-shadow:none;-webkit-appearance:none;-moz-appearance:none}.form-material__input:focus~.form-material__label,.form-material__input.ng-not-empty~.form-material__label{transform:translateY(-1.375rem);font-size:.8125rem}.form-material__input.ng-valid.ng-not-empty{border-color:var(--color-input-valid)!important;color:var(--form-material-text-color-valid, #000)}.form-material__input.ng-valid.ng-not-empty~.form-material__label{color:var(--form-material-valid-label-color, var(--color-input-valid))!important}.form-material__input.ng-valid.ng-not-empty~.form-material__arrow{border-top-color:var(--color-input-valid)}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_success{opacity:1}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_error{opacity:0!important}.form-material__input::-ms-clear{display:none}.form-material__input::-webkit-outer-spin-button,.form-material__input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.form-material__arrow{position:absolute;right:.9375rem;pointer-events:none;border-left:.3125rem solid transparent;border-right:.3125rem solid transparent;border-top:.375rem solid #727272}.form-material__label{font-family:var(--font-family-form-label, var(--font-family-secondary));transition:all .15s ease-in-out;font-size:1rem;position:absolute;pointer-events:none;color:var(--form-material-label-color, #999999);background:#fff}.form-material__icon-state{position:absolute;right:.9375rem;font-size:1.375rem;pointer-events:none;opacity:0}.form-material__icon-state_success{color:var(--form-material-color-icon-success, #00aec7)}.form-material__icon-state_error{color:#ff585d}.was-validate .form-material__input{border-color:#e4002b}.was-validate .form-material__label{color:#ff585d}.was-validate .form-material__icon-state_error{opacity:1}.was-validate .form-material__arrow{border-top-color:#ff585d}.was-validate .invalid-message{display:block;text-align:left}.invalid-message{font-weight:100!important;position:absolute;width:100%;margin-top:.25rem;min-height:1.2rem;color:#ff585d;bottom:-1.1rem;font-size:.8rem;display:none}\n"], directives: [{ type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i3.MinLengthValidator, selector: "[minlength][formControlName],[minlength][formControl],[minlength][ngModel]", inputs: ["minlength"] }, { type: i3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: TolowercaseDirective, selector: "[libTolowercase]", inputs: ["libTolowercase"] }, { type: DisableCopyPasteDirective, selector: "[appDisableCopyPaste]", inputs: ["appDisableCopyPaste"] }, { type: LimitNumberDirective, selector: "[appLimitNumberDirective]", inputs: ["appLimitNumberDirective"] }, { type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibInputMaterialDesignComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-input-material-design',
                    templateUrl: './lib-input-material-design.component.html',
                    styleUrls: [
                        './lib-input-material-design.component.scss',
                        '../../styles/_input.scss',
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: SuraFormService }, { type: ComponentValidatorService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], maxlength: [{
                type: Input
            }], minlength: [{
                type: Input
            }], inputType: [{
                type: Input
            }], enableCopyPaste: [{
                type: Input
            }], enableTolowercase: [{
                type: Input
            }], numberMaxlength: [{
                type: Input
            }], handleChange: [{
                type: Output
            }] } });

class LibInputSelectMaterialDesignComponent extends BaseInput {
    constructor(suraFormService, componentValidatorService, changeDetectorRef) {
        super();
        this.suraFormService = suraFormService;
        this.componentValidatorService = componentValidatorService;
        this.changeDetectorRef = changeDetectorRef;
        this.label = 'Seleccione una opción';
        this.keyValue = 'value';
        this.keyLabel = 'name';
    }
}
LibInputSelectMaterialDesignComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibInputSelectMaterialDesignComponent, deps: [{ token: SuraFormService }, { token: ComponentValidatorService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
LibInputSelectMaterialDesignComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibInputSelectMaterialDesignComponent, selector: "lib-input-select-material-design", inputs: { items: "items", label: "label", keyValue: "keyValue", keyLabel: "keyLabel" }, usesInheritance: true, ngImport: i0, template: "<div class=\"mb-3 position-relative\" [class.was-validate]=\"checkControl()\">\n  <div class=\"d-flex align-items-center form-material position-relative\">\n    <select\n      class=\"py-2 px-3 w-100 form-material__input\"\n      [formControl]=\"control\"\n      [class.ng-not-empty]=\"control.value\"\n      [id]=\"id\"\n      (change)=\"onChange($event)\"\n    >\n      <option value=\"\">{{ label }}</option>\n      <option *ngFor=\"let item of items\" value=\"{{ item[keyValue] }}\">\n        {{ item[keyLabel] }}\n      </option>\n    </select>\n    <label class=\"mx-2 px-2 mb-0 form-material__label\">{{ label }}</label>\n    <i class=\"form-material__arrow\"></i>\n  </div>\n  <div class=\"invalid-message\" *ngIf=\"control.errors\">\n    {{ showErrorMessage(control.errors) }}\n  </div>\n</div>\n", styles: ["", ".form-material{margin-bottom:1.7rem}.form-material__input{width:100%;background:#fff;border:.0625rem solid var(--form-material-input-border-color, #d2d2d2);outline:none;color:#000;font-size:1rem;border-radius:.25rem;font-family:var(--font-family-form-material, var(--font-family-secondary));box-shadow:none;-webkit-appearance:none;-moz-appearance:none}.form-material__input:focus~.form-material__label,.form-material__input.ng-not-empty~.form-material__label{transform:translateY(-1.375rem);font-size:.8125rem}.form-material__input.ng-valid.ng-not-empty{border-color:var(--color-input-valid)!important;color:var(--form-material-text-color-valid, #000)}.form-material__input.ng-valid.ng-not-empty~.form-material__label{color:var(--form-material-valid-label-color, var(--color-input-valid))!important}.form-material__input.ng-valid.ng-not-empty~.form-material__arrow{border-top-color:var(--color-input-valid)}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_success{opacity:1}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_error{opacity:0!important}.form-material__input::-ms-clear{display:none}.form-material__input::-webkit-outer-spin-button,.form-material__input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.form-material__arrow{position:absolute;right:.9375rem;pointer-events:none;border-left:.3125rem solid transparent;border-right:.3125rem solid transparent;border-top:.375rem solid #727272}.form-material__label{font-family:var(--font-family-form-label, var(--font-family-secondary));transition:all .15s ease-in-out;font-size:1rem;position:absolute;pointer-events:none;color:var(--form-material-label-color, #999999);background:#fff}.form-material__icon-state{position:absolute;right:.9375rem;font-size:1.375rem;pointer-events:none;opacity:0}.form-material__icon-state_success{color:var(--form-material-color-icon-success, #00aec7)}.form-material__icon-state_error{color:#ff585d}.was-validate .form-material__input{border-color:#e4002b}.was-validate .form-material__label{color:#ff585d}.was-validate .form-material__icon-state_error{opacity:1}.was-validate .form-material__arrow{border-top-color:#ff585d}.was-validate .invalid-message{display:block;text-align:left}.invalid-message{font-weight:100!important;position:absolute;width:100%;margin-top:.25rem;min-height:1.2rem;color:#ff585d;bottom:-1.1rem;font-size:.8rem;display:none}\n"], directives: [{ type: i3.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i3.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibInputSelectMaterialDesignComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-input-select-material-design',
                    templateUrl: './lib-input-select-material-design.component.html',
                    styleUrls: [
                        './lib-input-select-material-design.component.scss',
                        '../../styles/_input.scss',
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: SuraFormService }, { type: ComponentValidatorService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { items: [{
                type: Input
            }], label: [{
                type: Input
            }], keyValue: [{
                type: Input
            }], keyLabel: [{
                type: Input
            }] } });

const I18N_VALUES = {
    es: {
        weekdays: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
        months: [
            'Ene',
            'Feb',
            'Mar',
            'Abr',
            'May',
            'Jun',
            'Jul',
            'Ago',
            'Sep',
            'Oct',
            'Nov',
            'Dic',
        ],
    },
};
class I18n {
    constructor() {
        this.language = 'es';
    }
}
I18n.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: I18n, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
I18n.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: I18n });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: I18n, decorators: [{
            type: Injectable
        }] });
class CustomDatepickerI18n extends NgbDatepickerI18n {
    constructor(i18n) {
        super();
        this.i18n = i18n;
    }
    getWeekdayLabel() {
        return '';
    }
    getWeekdayShortName(weekday) {
        return I18N_VALUES[this.i18n.language].weekdays[weekday - 1];
    }
    getMonthShortName(month) {
        return I18N_VALUES[this.i18n.language].months[month - 1];
    }
    getMonthFullName(month) {
        return this.getMonthShortName(month);
    }
    getDayAriaLabel(date) {
        return `${date.day}-${date.month}-${date.year}`;
    }
}
CustomDatepickerI18n.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CustomDatepickerI18n, deps: [{ token: I18n }], target: i0.ɵɵFactoryTarget.Injectable });
CustomDatepickerI18n.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CustomDatepickerI18n });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CustomDatepickerI18n, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: I18n }]; } });

class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '-';
    }
    parse(value) {
        if (value) {
            const dateParts = value.trim().split(this.DELIMITER);
            if (dateParts.length === 1 && this.isNumber(dateParts[0])) {
                return { day: this.toInteger(dateParts[0]), month: null, year: null };
            }
            else if (dateParts.length === 2 &&
                this.isNumber(dateParts[0]) &&
                this.isNumber(dateParts[1])) {
                return {
                    day: this.toInteger(dateParts[0]),
                    month: this.toInteger(dateParts[1]),
                    year: null,
                };
            }
            else if (dateParts.length === 3 &&
                this.isNumber(dateParts[0]) &&
                this.isNumber(dateParts[1]) &&
                this.isNumber(dateParts[2])) {
                return {
                    day: this.toInteger(dateParts[0]),
                    month: this.toInteger(dateParts[1]),
                    year: this.toInteger(dateParts[2]),
                };
            }
        }
        return null;
    }
    format(date) {
        return date
            ? `${this.isNumber(date.day) ? this.padNumber(date.day) : ''}-${this.isNumber(date.month) ? this.padNumber(date.month) : ''}-${date.year}`
            : '';
    }
    toInteger(value) {
        return parseInt(`${value}`, 10);
    }
    isNumber(value) {
        return !isNaN(this.toInteger(value));
    }
    padNumber(value) {
        if (this.isNumber(value)) {
            return `0${value}`.slice(-2);
        }
        else {
            return '';
        }
    }
}
NgbDateCustomParserFormatter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: NgbDateCustomParserFormatter, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NgbDateCustomParserFormatter.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: NgbDateCustomParserFormatter });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: NgbDateCustomParserFormatter, decorators: [{
            type: Injectable
        }] });

class LibDatepickerComponent extends BaseInput {
    constructor(suraFormService, componentValidatorService, changeDetectorRef) {
        super();
        this.suraFormService = suraFormService;
        this.componentValidatorService = componentValidatorService;
        this.changeDetectorRef = changeDetectorRef;
        this.edadMinima = 90;
        this.minDate = { year: 1900, month: 1, day: 1 };
        this.navigation = 'select';
        this.outsideDays = 'visible';
        this.placeholder = 'DD-MM-AAAA';
        this.handleDateSelect = new EventEmitter();
    }
    /* La condición que se agrega en este metodo es debido a que ngbDate agrega por defecto su propio error de fecha y ese
    error se debe mapear para mostrar un mensaje al usuario. */
    showErrorMessage(errors) {
        const keyErrors = Object.keys(errors);
        let keyToSearch = keyErrors[0];
        if (keyErrors.includes(LibDatepickerComponent.NGB_DATE)) {
            keyToSearch = LibDatepickerComponent.INVALID_DATE;
        }
        return this.suraFormService.getErrorMessage(keyToSearch);
    }
    onDateSelect(event) {
        this.handleDateSelect.emit(event);
    }
}
LibDatepickerComponent.NGB_DATE = 'ngbDate';
LibDatepickerComponent.INVALID_DATE = 'INVALID_DATE';
LibDatepickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibDatepickerComponent, deps: [{ token: SuraFormService }, { token: ComponentValidatorService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
LibDatepickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibDatepickerComponent, selector: "lib-datepicker", inputs: { label: "label", edadMinima: "edadMinima", dayTemplate: "dayTemplate", dayTemplateData: "dayTemplateData", footerTemplate: "footerTemplate", displayMonths: "displayMonths", firstDayOfWeek: "firstDayOfWeek", markDisabled: "markDisabled", minDate: "minDate", maxDate: "maxDate", navigation: "navigation", outsideDays: "outsideDays", showWeekdays: "showWeekdays", showWeekNumbers: "showWeekNumbers", startDate: "startDate", placeholder: "placeholder" }, outputs: { handleDateSelect: "handleDateSelect" }, providers: [
        I18n,
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    ], usesInheritance: true, ngImport: i0, template: "<div class=\"mb-3 position-relative\" [class.was-validate]=\"checkControl()\">\n  <div class=\"d-flex align-items-center form-material position-relative\">\n    <input\n      [id]=\"id\"\n      class=\"py-2 px-3 form-material__input\"\n      [formControl]=\"control\"\n      [class.ng-not-empty]=\"control.value\"\n      ngbDatepicker\n      #datepicker=\"ngbDatepicker\"\n      [class.input-not-empty]=\"control.value\"\n      [placeholder]=\"placeholder\"\n      [dayTemplate]=\"dayTemplate\"\n      [dayTemplateData]=\"dayTemplateData\"\n      [displayMonths]=\"displayMonths\"\n      [firstDayOfWeek]=\"firstDayOfWeek\"\n      [footerTemplate]=\"footerTemplate\"\n      [markDisabled]=\"markDisabled\"\n      [maxDate]=\"maxDate\"\n      [minDate]=\"minDate\"\n      [navigation]=\"navigation\"\n      [outsideDays]=\"outsideDays\"\n      [showWeekdays]=\"showWeekdays\"\n      [showWeekNumbers]=\"showWeekNumbers\"\n      [startDate]=\"startDate\"\n      (dateSelect)=\"onDateSelect($event)\"\n      (click)=\"datepicker.open()\"\n    />\n    <label class=\"mx-2 px-2 mb-0 form-material__label\">{{ label }}</label>\n    <i\n      (click)=\"datepicker.toggle()\"\n      class=\"fal fa-calendar-alt position-absolute icon-calendar\"\n    ></i>\n  </div>\n  <div class=\"invalid-message\" *ngIf=\"control.errors\">\n    {{ showErrorMessage(control.errors) }}\n  </div>\n</div>\n", styles: [".icon-calendar{right:.9375rem;font-size:1.25rem;color:var(--color-icon-calendar, #727272);cursor:pointer}.was-validate .icon-calendar{color:#ff585d}.ng-valid~.icon-calendar{color:var(--color-icon-calendar-valid, var(--secondary))}\n", ".form-material{margin-bottom:1.7rem}.form-material__input{width:100%;background:#fff;border:.0625rem solid var(--form-material-input-border-color, #d2d2d2);outline:none;color:#000;font-size:1rem;border-radius:.25rem;font-family:var(--font-family-form-material, var(--font-family-secondary));box-shadow:none;-webkit-appearance:none;-moz-appearance:none}.form-material__input:focus~.form-material__label,.form-material__input.ng-not-empty~.form-material__label{transform:translateY(-1.375rem);font-size:.8125rem}.form-material__input.ng-valid.ng-not-empty{border-color:var(--color-input-valid)!important;color:var(--form-material-text-color-valid, #000)}.form-material__input.ng-valid.ng-not-empty~.form-material__label{color:var(--form-material-valid-label-color, var(--color-input-valid))!important}.form-material__input.ng-valid.ng-not-empty~.form-material__arrow{border-top-color:var(--color-input-valid)}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_success{opacity:1}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_error{opacity:0!important}.form-material__input::-ms-clear{display:none}.form-material__input::-webkit-outer-spin-button,.form-material__input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.form-material__arrow{position:absolute;right:.9375rem;pointer-events:none;border-left:.3125rem solid transparent;border-right:.3125rem solid transparent;border-top:.375rem solid #727272}.form-material__label{font-family:var(--font-family-form-label, var(--font-family-secondary));transition:all .15s ease-in-out;font-size:1rem;position:absolute;pointer-events:none;color:var(--form-material-label-color, #999999);background:#fff}.form-material__icon-state{position:absolute;right:.9375rem;font-size:1.375rem;pointer-events:none;opacity:0}.form-material__icon-state_success{color:var(--form-material-color-icon-success, #00aec7)}.form-material__icon-state_error{color:#ff585d}.was-validate .form-material__input{border-color:#e4002b}.was-validate .form-material__label{color:#ff585d}.was-validate .form-material__icon-state_error{opacity:1}.was-validate .form-material__arrow{border-top-color:#ff585d}.was-validate .invalid-message{display:block;text-align:left}.invalid-message{font-weight:100!important;position:absolute;width:100%;margin-top:.25rem;min-height:1.2rem;color:#ff585d;bottom:-1.1rem;font-size:.8rem;display:none}\n"], directives: [{ type: i1$2.NgbInputDatepicker, selector: "input[ngbDatepicker]", inputs: ["showWeekdays", "weekdays", "disabled", "autoClose", "datepickerClass", "dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "minDate", "maxDate", "navigation", "outsideDays", "placement", "restoreFocus", "showWeekNumbers", "startDate", "container", "positionTarget"], outputs: ["dateSelect", "navigate", "closed"], exportAs: ["ngbDatepicker"] }, { type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibDatepickerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-datepicker',
                    templateUrl: './lib-datepicker.component.html',
                    styleUrls: ['./lib-datepicker.component.scss', '../../styles/_input.scss'],
                    providers: [
                        I18n,
                        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
                        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: SuraFormService }, { type: ComponentValidatorService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], edadMinima: [{
                type: Input
            }], dayTemplate: [{
                type: Input
            }], dayTemplateData: [{
                type: Input
            }], footerTemplate: [{
                type: Input
            }], displayMonths: [{
                type: Input
            }], firstDayOfWeek: [{
                type: Input
            }], markDisabled: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], navigation: [{
                type: Input
            }], outsideDays: [{
                type: Input
            }], showWeekdays: [{
                type: Input
            }], showWeekNumbers: [{
                type: Input
            }], startDate: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], handleDateSelect: [{
                type: Output
            }] } });

class LibTypeaheadComponent extends BaseInput {
    constructor(suraFormService, componentValidatorService, changeDetectorRef) {
        super();
        this.suraFormService = suraFormService;
        this.componentValidatorService = componentValidatorService;
        this.changeDetectorRef = changeDetectorRef;
        this.itemWithoutAccent = false;
        this.label = 'Seleccione una opción';
        this.keyToShow = 'name';
        this.itemSelected = new EventEmitter();
        this.subscription = new Subscription();
        this.showItemsOnFocus = false;
        this.numberOfItemsToShow = 10;
        this.focus$ = new Subject();
        this.click$ = new Subject();
        this.search = (text$) => {
            const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
            const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
            const inputFocus$ = this.focus$;
            return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => {
                let filterByText = term.length < 2;
                let items = [];
                if (this.showItemsOnFocus) {
                    filterByText = term === '';
                    items = this.items.slice(0, this.numberOfItemsToShow);
                }
                return filterByText
                    ? items
                    : this.items
                        .filter(item => this.itemWithoutAccent
                        ? this.eliminarDiacriticos(item[this.keyToShow])
                            .toLowerCase()
                            .indexOf(term.toLowerCase()) > -1
                        : item[this.keyToShow]
                            .toLowerCase()
                            .indexOf(term.toLowerCase()) > -1)
                        .slice(0, this.numberOfItemsToShow);
            }));
        };
        this.formatter = (item) => item[this.keyToShow];
    }
    ngOnInit() {
        this.subscribeToControl();
    }
    subscribeToControl() {
        this.subscription.add(this.control.valueChanges.subscribe((item) => {
            if (typeof item === 'string') {
                this.checkValidation(item);
            }
        }));
    }
    checkValidation(value) {
        const valor = this.items.filter(item => item[this.keyToShow] === value);
        if (valor[0]) {
            this.control.setValue(valor[0]);
        }
        else {
            this.itemSelected.emit(null);
            this.control.setErrors({ INVALID_TYPEAHEAD: true });
        }
    }
    eliminarDiacriticos(texto) {
        return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    selectItem(event) {
        this.itemSelected.emit(event);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
LibTypeaheadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibTypeaheadComponent, deps: [{ token: SuraFormService }, { token: ComponentValidatorService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
LibTypeaheadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibTypeaheadComponent, selector: "lib-typeahead", inputs: { itemWithoutAccent: "itemWithoutAccent", label: "label", items: "items", keyToShow: "keyToShow", showItemsOnFocus: "showItemsOnFocus", numberOfItemsToShow: "numberOfItemsToShow" }, outputs: { itemSelected: "itemSelected" }, viewQueries: [{ propertyName: "instance", first: true, predicate: ["instance"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"mb-3 position-relative\" [class.was-validate]=\"checkControl()\">\n  <div class=\"d-flex align-items-center form-material position-relative\">\n    <input\n      type=\"text\"\n      class=\"py-2 px-3 form-material__input\"\n      [formControl]=\"control\"\n      [ngbTypeahead]=\"search\"\n      [class.ng-not-empty]=\"control.value\"\n      [id]=\"id\"\n      [editable]=\"true\"\n      (selectItem)=\"selectItem($event)\"\n      [inputFormatter]=\"formatter\"\n      [resultFormatter]=\"formatter\"\n      (focus)=\"showItemsOnFocus && focus$.next($event.target.value)\"\n      (click)=\"showItemsOnFocus && click$.next($event.target.value)\"\n      #instance=\"ngbTypeahead\"\n    />\n    <label class=\"mx-2 px-2 mb-0 form-material__label\">{{ label }}</label>\n    <i\n      class=\"fal fa-check form-material__icon-state form-material__icon-state_success\"\n    ></i>\n    <i\n      class=\"fal fa-times form-material__icon-state form-material__icon-state_error\"\n    ></i>\n  </div>\n  <div class=\"invalid-message\" *ngIf=\"control.errors\">\n    {{ showErrorMessage(control.errors) }}\n  </div>\n</div>\n", styles: [".form-material{margin-bottom:1.7rem}.form-material__input{width:100%;background:#fff;border:.0625rem solid var(--form-material-input-border-color, #d2d2d2);outline:none;color:#000;font-size:1rem;border-radius:.25rem;font-family:var(--font-family-form-material, var(--font-family-secondary));box-shadow:none;-webkit-appearance:none;-moz-appearance:none}.form-material__input:focus~.form-material__label,.form-material__input.ng-not-empty~.form-material__label{transform:translateY(-1.375rem);font-size:.8125rem}.form-material__input.ng-valid.ng-not-empty{border-color:var(--color-input-valid)!important;color:var(--form-material-text-color-valid, #000)}.form-material__input.ng-valid.ng-not-empty~.form-material__label{color:var(--form-material-valid-label-color, var(--color-input-valid))!important}.form-material__input.ng-valid.ng-not-empty~.form-material__arrow{border-top-color:var(--color-input-valid)}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_success{opacity:1}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_error{opacity:0!important}.form-material__input::-ms-clear{display:none}.form-material__input::-webkit-outer-spin-button,.form-material__input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.form-material__arrow{position:absolute;right:.9375rem;pointer-events:none;border-left:.3125rem solid transparent;border-right:.3125rem solid transparent;border-top:.375rem solid #727272}.form-material__label{font-family:var(--font-family-form-label, var(--font-family-secondary));transition:all .15s ease-in-out;font-size:1rem;position:absolute;pointer-events:none;color:var(--form-material-label-color, #999999);background:#fff}.form-material__icon-state{position:absolute;right:.9375rem;font-size:1.375rem;pointer-events:none;opacity:0}.form-material__icon-state_success{color:var(--form-material-color-icon-success, #00aec7)}.form-material__icon-state_error{color:#ff585d}.was-validate .form-material__input{border-color:#e4002b}.was-validate .form-material__label{color:#ff585d}.was-validate .form-material__icon-state_error{opacity:1}.was-validate .form-material__arrow{border-top-color:#ff585d}.was-validate .invalid-message{display:block;text-align:left}.invalid-message{font-weight:100!important;position:absolute;width:100%;margin-top:.25rem;min-height:1.2rem;color:#ff585d;bottom:-1.1rem;font-size:.8rem;display:none}\n"], directives: [{ type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$2.NgbTypeahead, selector: "input[ngbTypeahead]", inputs: ["autocomplete", "placement", "container", "editable", "focusFirst", "showHint", "inputFormatter", "ngbTypeahead", "resultFormatter", "resultTemplate", "popupClass"], outputs: ["selectItem"], exportAs: ["ngbTypeahead"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibTypeaheadComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-typeahead',
                    templateUrl: './lib-typeahead.component.html',
                    styleUrls: ['../../styles/_input.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: SuraFormService }, { type: ComponentValidatorService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { itemWithoutAccent: [{
                type: Input
            }], label: [{
                type: Input
            }], items: [{
                type: Input
            }], keyToShow: [{
                type: Input
            }], itemSelected: [{
                type: Output
            }], showItemsOnFocus: [{
                type: Input
            }], numberOfItemsToShow: [{
                type: Input
            }], instance: [{
                type: ViewChild,
                args: ['instance', { static: true }]
            }] } });

class LibSwitchComponent {
    constructor() {
        this.toggleSwitch = new EventEmitter();
    }
    toggle() {
        this.toggleSwitch.emit();
    }
}
LibSwitchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibSwitchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LibSwitchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibSwitchComponent, selector: "lib-switch", inputs: { isActive: "isActive" }, outputs: { toggleSwitch: "toggleSwitch" }, ngImport: i0, template: "<div class=\"switch\">\n  <input type=\"checkbox\" id=\"switch\" class=\"switch__input\" />\n  <label for=\"switch\" class=\"switch__label\" (click)=\"toggle()\">\n    <span\n      class=\"switch__text\"\n      [ngClass]=\"isActive ? 'switch__text_yes' : 'switch__text_no'\"\n      >{{ isActive ? 'Si' : 'No' }}</span\n    >\n  </label>\n</div>\n", styles: [".switch{display:flex}.switch__input{height:0;width:0;visibility:hidden}.switch__input:checked+.switch__label{background-color:#2ac13e}.switch__input:checked+.switch__label:after{left:calc(100% - .3125rem);transform:translate(-100%)}.switch__label{display:flex;align-items:center;cursor:pointer;position:relative;width:3.125rem;height:1.5625rem;background-color:#727272;border-radius:6.25rem;margin-bottom:0}.switch__label:after{content:\"\";position:absolute;top:.2125rem;left:.3125rem;width:1.125rem;height:1.125rem;background-color:#fff;border-radius:5.625rem;transition:.3s}.switch__label:active:after{width:1.875rem}.switch__text{color:#fff;font-size:.9rem}.switch__text_yes{margin-right:auto;margin-left:.625rem}.switch__text_no{margin-left:auto;margin-right:.3125rem}\n"], directives: [{ type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibSwitchComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-switch',
                    templateUrl: './lib-switch.component.html',
                    styleUrls: ['./lib-switch.component.scss'],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { isActive: [{
                type: Input
            }], toggleSwitch: [{
                type: Output
            }] } });

class FocusOnErrorDirective {
    constructor(el) {
        this.el = el;
    }
    onFormSubmit() {
        const focusables = ['input', 'select', 'textarea'];
        const invalidInput = this.el.nativeElement.querySelector(focusables.map(x => `${x}.ng-invalid`).join(','));
        if (invalidInput) {
            invalidInput.focus();
        }
    }
}
FocusOnErrorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FocusOnErrorDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
FocusOnErrorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: FocusOnErrorDirective, selector: "form", host: { listeners: { "submit": "onFormSubmit()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FocusOnErrorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'form',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { onFormSubmit: [{
                type: HostListener,
                args: ['submit']
            }] } });

/**
 * Modulo que se injecta en el modulo de la aplicación a usar.
 *
 * @args errorMessages: Objeto con los mensajes de error de inputs.
 *
 * imports: [
 *  SuraFormModule.forRoot(
 *      errorMessages
 *   ),
 * ]
 */
class SuraFormModule {
    static forRoot(errorMessages) {
        return {
            ngModule: SuraFormModule,
            providers: [
                {
                    provide: ERROR_MESSAGES,
                    useValue: errorMessages,
                },
            ],
        };
    }
}
SuraFormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SuraFormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormModule, declarations: [TolowercaseDirective,
        DisableCopyPasteDirective,
        LimitNumberDirective,
        LibInputMaterialDesignComponent,
        LibInputSelectMaterialDesignComponent,
        LibDatepickerComponent,
        LibTypeaheadComponent,
        LibSwitchComponent,
        FocusOnErrorDirective], imports: [CommonModule,
        ReactiveFormsModule,
        NgbDatepickerModule,
        NgbTypeaheadModule], exports: [TolowercaseDirective,
        DisableCopyPasteDirective,
        LimitNumberDirective,
        LibInputMaterialDesignComponent,
        LibInputSelectMaterialDesignComponent,
        LibDatepickerComponent,
        LibTypeaheadComponent,
        LibSwitchComponent,
        FocusOnErrorDirective] });
SuraFormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormModule, providers: [SuraFormService, ComponentValidatorService], imports: [[
            CommonModule,
            ReactiveFormsModule,
            NgbDatepickerModule,
            NgbTypeaheadModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        NgbDatepickerModule,
                        NgbTypeaheadModule,
                    ],
                    providers: [SuraFormService, ComponentValidatorService],
                    declarations: [
                        TolowercaseDirective,
                        DisableCopyPasteDirective,
                        LimitNumberDirective,
                        LibInputMaterialDesignComponent,
                        LibInputSelectMaterialDesignComponent,
                        LibDatepickerComponent,
                        LibTypeaheadComponent,
                        LibSwitchComponent,
                        FocusOnErrorDirective,
                    ],
                    exports: [
                        TolowercaseDirective,
                        DisableCopyPasteDirective,
                        LimitNumberDirective,
                        LibInputMaterialDesignComponent,
                        LibInputSelectMaterialDesignComponent,
                        LibDatepickerComponent,
                        LibTypeaheadComponent,
                        LibSwitchComponent,
                        FocusOnErrorDirective,
                    ],
                }]
        }] });

const errorMessages = [
    {
        key: 'REQUIRED',
        errorMessage: 'Requerido',
    },
    {
        key: 'INVALID_ONLY_NUMBERS',
        errorMessage: 'Este campo solo permite números',
    },
    {
        key: 'INVALID_PLACA',
        errorMessage: 'La placa digitada es inválida',
    },
    {
        key: 'INVALID_PLACA_AUTOMOVIL',
        errorMessage: 'La placa digitada es inválida',
    },
    {
        key: 'INVALID_ONLY_LETTERS',
        errorMessage: 'Este campo solo permite letras',
    },
    {
        key: 'INVALID_MINIMUN_CHARATERS',
        errorMessage: 'Este campo no cumple con el mínimo de caracteres',
    },
    {
        key: 'minlength MINLENGTH',
        errorMessage: 'Este campo no cumple con el mínimo de caracteres',
    },
    {
        key: 'INVALID_ADDRESS',
        errorMessage: 'Digite una dirección valida',
    },
    {
        key: 'INVALID_EMAIL',
        errorMessage: 'Email inválido',
    },
    {
        key: 'INVALID_EMAIL_UNE',
        errorMessage: 'Correo inválido, por favor ingresa uno diferente a UNE.  ',
    },
    {
        key: 'INVALID_ONLY_CELL_PHONE',
        errorMessage: 'Número de celular inválido',
    },
    {
        key: 'INVALID_MODELO_VEHICULO',
        errorMessage: 'El modelo debe ser menor de 20 años',
    },
    {
        key: 'INVALID_NUMERO_DOCUMENTO',
        errorMessage: 'Digite una cédula de ciudadanía valida',
    },
    {
        key: 'INVALID_CEDULA_EXTRANJERIA',
        errorMessage: 'Digite una cédula de extranjería valida',
    },
    {
        key: 'INVALID_PASAPORTE',
        errorMessage: 'Digite un pasaporte valido',
    },
    {
        key: 'INVALID_MAYOR_DE_EDAD',
        errorMessage: 'La edad mínima es 18 años',
    },
    {
        key: 'INVALID_FECHA_EXPEDICION_CON_FECHA_NACIMIENTO',
        errorMessage: 'Digite una fecha de expedición valida',
    },
    {
        key: 'INVALID_DATE_LESS_TODAY',
        errorMessage: 'La fecha no puede ser superior a hoy',
    },
    {
        key: 'INVALID_NUMBER_PHONE',
        errorMessage: 'Numero de telefono inválido',
    },
    {
        key: 'INVALID_EDAD_MAXIMA',
        errorMessage: 'Supera la edad máxima',
    },
    {
        key: 'INVALID_DATE',
        errorMessage: 'Ingrese una fecha valida',
    },
    {
        key: 'INVALID_TYPEAHEAD',
        errorMessage: 'Seleccione un item de la lista',
    },
];

class AsesorComponent {
    constructor(asesoresService) {
        this.asesoresService = asesoresService;
        this.itemsParsed = [];
        this.observableAsesoresEmit = 0;
        this.markSwitchAsDisabled = false;
        this.isAsesorCodeInvalid = false;
        this.isDefaultAsesor = false;
        this.hasSwitch = true;
        this.disabled = false;
        this.isSuraTenant = true;
        this.maxItemsToShow = 6;
        this.wasValidate = false;
        this.maxCharactersCode = 6;
        this.subscription = new Subscription();
        this.changeAsesor = new EventEmitter();
        this.activeChange = new EventEmitter();
    }
    ngOnInit() {
        const requestParam = this.asesorCode
            ? this.asesorCode
            : this.defaultAsesorCode;
        this.asesoresService.fetchAsesor(requestParam);
        this.subscription.add(this.subscribeToLoadAsesores());
        this.subscription.add(this.subscribeToFormChanges());
    }
    onInputChange(codigo) {
        if (codigo.length > 2 && /^[a-zA-Z0-9\s]+$/.test(codigo)) {
            this.asesoresService.fetchAsesor(codigo);
        }
    }
    toggleChange() {
        if (!this.markSwitchAsDisabled) {
            this.active = !this.active;
            this.activeChange.emit(this.active);
        }
        if (!this.active) {
            this.form.reset('');
            this.form.setErrors(null);
            this.itemsParsed = [];
        }
    }
    subscribeToLoadAsesores() {
        return this.asesoresService
            .getAsesor()
            .subscribe((asesores) => {
            this.observableAsesoresEmit++;
            if (this.observableAsesoresEmit === 2 &&
                this.asesorCode !== this.defaultAsesorCode &&
                !asesores.length) {
                this.isAsesorCodeInvalid = true;
                this.onInputChange(this.defaultAsesorCode);
                return;
            }
            if (this.observableAsesoresEmit === 2 &&
                Array.isArray(asesores) &&
                asesores.length) {
                if (this.isDefaultAsesor) {
                    this.defaultAsesor = asesores[0];
                    this.changeAsesor.emit(this.defaultAsesor);
                    return;
                }
                this.handleAsesoresList(asesores);
                this.setAsesorByUrl();
                return;
            }
            if (this.isAsesorCodeInvalid && asesores.length) {
                this.isAsesorCodeInvalid = !this.isAsesorCodeInvalid;
                this.defaultAsesor = asesores[0];
                this.changeAsesor.emit(this.defaultAsesor);
                return;
            }
            if (Array.isArray(asesores) && asesores.length)
                this.handleAsesoresList(asesores);
        });
    }
    subscribeToFormChanges() {
        return this.form.valueChanges.subscribe((value) => {
            this.onInputChange(value);
        });
    }
    handleAsesoresList(asesores) {
        this.asesores = asesores;
        const items = this.asesores.map((asesor) => ({
            name: asesor.nombreCodigo,
            value: asesor.codigo,
        }));
        this.itemsParsed = items || [];
    }
    setAsesorByUrl() {
        const asesorFinded = this.asesores.find(asesor => asesor.codigo === this.asesorCode);
        const asesorTosetInInput = this.itemsParsed.find(asesor => asesor.value === this.asesorCode);
        if (asesorFinded) {
            this.asesor = asesorFinded;
            this.form.setValue(asesorTosetInInput);
            this.form.disable();
            this.hasSwitch = false;
            this.changeAsesor.emit(this.asesor);
            this.toggleChange();
        }
    }
    getAsesorSelected(itemSelected) {
        if (itemSelected) {
            this.asesor = this.findAsesorByCode(itemSelected);
            this.changeAsesor.emit(this.asesor);
        }
        else {
            this.changeAsesor.emit(this.defaultAsesor);
        }
    }
    findAsesorByCode(codigo) {
        return this.asesores.find(asesor => asesor.codigo === codigo);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
AsesorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AsesorComponent, deps: [{ token: i1.SuraAsesoresService }], target: i0.ɵɵFactoryTarget.Component });
AsesorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AsesorComponent, selector: "lib-asesor", inputs: { asesorCode: "asesorCode", defaultAsesorCode: "defaultAsesorCode", isDefaultAsesor: "isDefaultAsesor", active: "active", form: "form", hasSwitch: "hasSwitch", disabled: "disabled", isSuraTenant: "isSuraTenant", maxItemsToShow: "maxItemsToShow", wasValidate: "wasValidate", maxCharactersCode: "maxCharactersCode" }, outputs: { changeAsesor: "changeAsesor", activeChange: "activeChange" }, ngImport: i0, template: "<div class=\"container-lib-asesor\">\n  <div class=\"d-flex align-items-center\">\n    <div class=\"my-2 col-10 col-md-9 col-lg-10 px-0\">\n      <ng-content></ng-content>\n    </div>\n    <div *ngIf=\"hasSwitch\" class=\"col-2 col-md-3 col-lg-2 px-0\">\n      <lib-switch\n        [isActive]=\"active\"\n        (toggleSwitch)=\"toggleChange()\"\n      ></lib-switch>\n    </div>\n  </div>\n  <lib-typeahead\n    *ngIf=\"active && isSuraTenant\"\n    id=\"asesor\"\n    label=\"asesor\"\n    keyToShow=\"name\"\n    [items]=\"itemsParsed\"\n    [control]=\"form\"\n    [wasValidate]=\"wasValidate\"\n    [showItemsOnFocus]=\"true\"\n    [itemWithoutAccent]=\"true\"\n    [numberOfItemsToShow]=\"maxItemsToShow\"\n    (itemSelected)=\"getAsesorSelected($event ? $event.item.value : $event)\"\n  >\n  </lib-typeahead>\n\n  <input-material-design\n    *ngIf=\"(active || !hasSwitch) && !isSuraTenant\"\n    label=\"Codigo Asesor\"\n    [formControl]=\"form\"\n    type=\"number\"\n    errorposition=\"left\"\n    id=\"id-codigo-asesor\"\n    ngDefaultControl\n    [wasvalidate]=\"wasValidate\"\n    [validateErrors]\n    [appLimitNumberDirective]=\"maxCharactersCode\"\n  ></input-material-design>\n</div>\n", styles: [".container-lib-asesor{display:flex;flex-direction:column}\n"], components: [{ type: LibSwitchComponent, selector: "lib-switch", inputs: ["isActive"], outputs: ["toggleSwitch"] }, { type: LibTypeaheadComponent, selector: "lib-typeahead", inputs: ["itemWithoutAccent", "label", "items", "keyToShow", "showItemsOnFocus", "numberOfItemsToShow"], outputs: ["itemSelected"] }], directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i1.ErrorManageDirective, selector: "[validateErrors]", inputs: ["inputTextErrorControl", "formStatus", "wasvalidate"] }, { type: i1.LimitNumberDirective, selector: "[appLimitNumberDirective]", inputs: ["appLimitNumberDirective"] }, { type: LimitNumberDirective, selector: "[appLimitNumberDirective]", inputs: ["appLimitNumberDirective"] }], viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AsesorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-asesor',
                    templateUrl: './asesor.component.html',
                    styleUrls: ['./asesor.component.scss'],
                    viewProviders: [
                        { provide: ControlContainer, useExisting: FormGroupDirective },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i1.SuraAsesoresService }]; }, propDecorators: { asesorCode: [{
                type: Input
            }], defaultAsesorCode: [{
                type: Input
            }], isDefaultAsesor: [{
                type: Input
            }], active: [{
                type: Input
            }], form: [{
                type: Input
            }], hasSwitch: [{
                type: Input
            }], disabled: [{
                type: Input
            }], isSuraTenant: [{
                type: Input
            }], maxItemsToShow: [{
                type: Input
            }], wasValidate: [{
                type: Input
            }], maxCharactersCode: [{
                type: Input
            }], changeAsesor: [{
                type: Output
            }], activeChange: [{
                type: Output
            }] } });

class CommonComponentsModule {
}
CommonComponentsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CommonComponentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CommonComponentsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CommonComponentsModule, declarations: [AsesoresComponent,
        AsesorComponent,
        PaginaNoEncontradaComponent,
        PaginaErrorComponent,
        SuraButtonComponent,
        ConfirmationModalComponent,
        ChatbotTibotComponent], imports: [CommonModule,
        ReactiveFormsModule,
        RouterModule,
        ErrorManage,
        LimitNumber, SuraFormModule], exports: [AsesoresComponent,
        AsesorComponent,
        PaginaNoEncontradaComponent,
        PaginaErrorComponent,
        SuraButtonComponent,
        ConfirmationModalComponent,
        ChatbotTibotComponent] });
CommonComponentsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CommonComponentsModule, imports: [[
            CommonModule,
            ReactiveFormsModule,
            RouterModule,
            ErrorManage,
            LimitNumber,
            SuraFormModule.forRoot(errorMessages),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CommonComponentsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AsesoresComponent,
                        AsesorComponent,
                        PaginaNoEncontradaComponent,
                        PaginaErrorComponent,
                        SuraButtonComponent,
                        ConfirmationModalComponent,
                        ChatbotTibotComponent,
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        RouterModule,
                        ErrorManage,
                        LimitNumber,
                        SuraFormModule.forRoot(errorMessages),
                    ],
                    exports: [
                        AsesoresComponent,
                        AsesorComponent,
                        PaginaNoEncontradaComponent,
                        PaginaErrorComponent,
                        SuraButtonComponent,
                        ConfirmationModalComponent,
                        ChatbotTibotComponent,
                    ],
                    entryComponents: [],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class QuestionComponent {
    constructor(cdr) {
        this.cdr = cdr;
    }
    ngOnInit() {
        this.setRespuestasOptions();
    }
    ngAfterViewInit() {
        this.cdr.detectChanges();
    }
    get getControl() {
        return this.myform.get(this.pregunta.id);
    }
    setRespuestasOptions() {
        const answerOptions = this.pregunta.answer.map((answer, index) => ({
            value: index,
            name: answer.value.toUpperCase(),
        }));
        this.respuestasOptions = JSON.stringify(answerOptions);
    }
}
QuestionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: QuestionComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
QuestionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: QuestionComponent, selector: "app-question", inputs: { pregunta: "pregunta", myform: "myform", isFormSubmitted: "isFormSubmitted", indexPregunta: "indexPregunta" }, ngImport: i0, template: "<div [formGroup]=\"myform\" *ngIf=\"pregunta\" class=\"pb-4\">\n  <div class=\"col-12 pb-2\">\n    <p class=\"text-question\">{{ pregunta.text }}</p>\n  </div>\n  <div class=\"row mx-1\">\n    <div\n      class=\"col-6 d-none d-md-flex\"\n      *ngFor=\"let opcion of pregunta.answer; let i = index\"\n    >\n      <input\n        class=\"question__radio\"\n        type=\"radio\"\n        id=\"pregunta{{ indexPregunta }}-resp-{{ i }}\"\n        [formControlName]=\"pregunta.id\"\n        [value]=\"i\"\n        required\n      />\n      <label\n        for=\"pregunta{{ indexPregunta }}-resp-{{ i }}\"\n        class=\"text-center question__label\"\n      >\n        <p class=\"h3 text-respuesta mb-0 pl-2\">{{ opcion.value }}</p>\n      </label>\n    </div>\n    <div class=\"d-block d-md-none col-12\">\n      <select-material-design\n        [items]=\"respuestasOptions\"\n        id=\"pregunta-{{ indexPregunta }}\"\n        [formControl]=\"getControl\"\n        defaultoption=\"Elige una opci\u00F3n\"\n        [validateErrors]\n        [wasvalidate]=\"isFormSubmitted\"\n      >\n      </select-material-design>\n    </div>\n    <div\n      *ngIf=\"getControl.errors && getControl.errors.required && isFormSubmitted\"\n      class=\"invalid-input text-center\"\n    >\n      Por favor elige una opci\u00F3n\n    </div>\n  </div>\n</div>\n", styles: [".text-question{text-align:left;font-size:1rem;font-family:\"Barlow\";letter-spacing:0;color:#666;opacity:1}.text-respuesta{text-align:left;font-size:.9rem;font-family:\"Barlow\";letter-spacing:0;color:#999;text-transform:uppercase;opacity:1}.question__radio{display:none}.question__radio:not(:disabled)~label{cursor:pointer}.question__radio:disabled~label{color:#bcc2bf;border-color:#bcc2bf;box-shadow:none;cursor:not-allowed}.question__radio:not(:checked)+label:after{color:#fff;font-family:\"Font Awesome 5 Pro\";border:2px solid #999999;content:\"\\f111\";font-size:.8rem;font-weight:900;transform:translate(-50%);height:1.2rem;width:1.2rem;text-align:center;line-height:1.1rem;border-radius:50%;box-shadow:0 2px 5px -2px #00000040;position:absolute;left:0;top:.4rem}.question__radio:checked+label:after{color:var(--primary);font-family:\"Font Awesome 5 Pro\";border:2px solid var(--primary);content:\"\\f111\";font-size:.8rem;font-weight:900;transform:translate(-50%);height:1.2rem;width:1.2rem;text-align:center;line-height:1.1rem;border-radius:50%;position:absolute;left:0;top:.4rem}.question__label{height:100%;display:block;margin:0;position:relative;padding:.5rem;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box}.invalid-input{width:100%;margin-top:.25rem;font-size:80%;min-height:1.2rem;color:#dc3545}\n"], directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i1.ErrorManageDirective, selector: "[validateErrors]", inputs: ["inputTextErrorControl", "formStatus", "wasvalidate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: QuestionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-question',
                    templateUrl: './question.component.html',
                    styleUrls: ['./question.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { pregunta: [{
                type: Input
            }], myform: [{
                type: Input
            }], isFormSubmitted: [{
                type: Input
            }], indexPregunta: [{
                type: Input
            }] } });

var CifinLoadingTags;
(function (CifinLoadingTags) {
    CifinLoadingTags["CARGANDO_PREGUNTAS"] = "Cargando preguntas CIFIN";
    CifinLoadingTags["GUARDANDO_RESPUESTAS"] = "Guardando respuestas";
})(CifinLoadingTags || (CifinLoadingTags = {}));

var CifinErrors;
(function (CifinErrors) {
    CifinErrors["OBTENIENDO_PREGUNTAS"] = "Ocurri\u00F3 un problema al cargar las preguntas";
    CifinErrors["GUARDANDO_RESPUESTAS"] = "Ocurri\u00F3 un problema al guardar las respuestas";
    CifinErrors["INTERNAL_BAD_GETWAY"] = "Servicio no disponible, intente mas tarde";
    CifinErrors["NO_EXISTEN_PREGUNTAS"] = "No existen preguntas para realizar la validaci\u00F3n";
    CifinErrors["TU_BLOQUEADO"] = "Los sentimos, has superado el l\u00EDmite de intentos";
    CifinErrors["ERROR_EN_INTENTO"] = "Por favor valida bien tu informaci\u00F3n e int\u00E9ntalo de nuevo.";
    CifinErrors["CUESTIONARIO_INCOMPLETO"] = "Debes responder todas las preguntas";
    // tslint:disable-next-line: max-line-length
    CifinErrors["USUARIO_NO_REGISTRADO"] = "Usted no se encuentra registrado en el sistema de informaci\u00F3n financiera. Para realizar este proceso es necesario encontrarse registrado en CIFIN";
})(CifinErrors || (CifinErrors = {}));

var OriginCifinResponse;
(function (OriginCifinResponse) {
    OriginCifinResponse["TRANSUNION"] = "TU";
    OriginCifinResponse["SURA"] = "SURA";
    OriginCifinResponse["TEST"] = "TEST";
})(OriginCifinResponse || (OriginCifinResponse = {}));

var CifinResponses;
(function (CifinResponses) {
    CifinResponses["CUESTIONARIO_BLOQUEADO"] = "Lockout";
    CifinResponses["CUSTIONARIO_VALIDO"] = "ShowExam";
    CifinResponses["RESPUESTAS_ERRONEAS"] = "Fail";
    CifinResponses["NO_EXISTE_CUESTIONARIO_EN_COLA"] = "Failed";
})(CifinResponses || (CifinResponses = {}));

var CifinFieldKey;
(function (CifinFieldKey) {
    CifinFieldKey["ANSWER_DATA"] = "AnswerData";
    CifinFieldKey["EXAM_DATA"] = "ExamData";
})(CifinFieldKey || (CifinFieldKey = {}));

const HEADER_NO_SECURE = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
    }),
};
const getSecureHeader = () => {
    return {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        }),
    };
};

class RestHttpClientService {
    constructor(http) {
        this.http = http;
    }
    post(body, url, headers) {
        return this.http.post(url, body, headers);
    }
    put(body, url, headers) {
        return this.http.put(url, body, headers);
    }
    get(url, headers) {
        return this.http.get(url, headers);
    }
    delete(url, headers) {
        return this.http.delete(url, headers);
    }
}
RestHttpClientService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RestHttpClientService, deps: [{ token: i1$3.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
RestHttpClientService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RestHttpClientService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RestHttpClientService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.HttpClient }]; } });

/***LIBRARIES***/
class CifinService {
    constructor(apiBaseRenting, http, restHttpClientService) {
        this.apiBaseRenting = apiBaseRenting;
        this.http = http;
        this.restHttpClientService = restHttpClientService;
    }
    getCifin(tipoDocumento, numeroDocumento, lastName1) {
        return this.restHttpClientService.post({
            IdType: tipoDocumento,
            CustomerId: numeroDocumento,
            lastName: lastName1,
        }, `${this.apiBaseRenting}${CifinService.QUESTIONS_ENDPOINT}`, getSecureHeader());
    }
    reportePromotoraCifin(body) {
        return this.restHttpClientService.post(body, `${this.apiBaseRenting}${CifinService.NOTIFY_CIFIN_REJECTION_ENDPOINT}`, getSecureHeader());
    }
    respuestasCifin(respuestas) {
        return this.restHttpClientService.post(respuestas, `${this.apiBaseRenting}${CifinService.VALIDATE_ANSWERS_ENDPOINT}`, getSecureHeader());
    }
}
CifinService.QUESTIONS_ENDPOINT = `/getquestions`;
CifinService.NOTIFY_CIFIN_REJECTION_ENDPOINT = `/notifycifinrejection`;
CifinService.VALIDATE_ANSWERS_ENDPOINT = `/validateanswers`;
CifinService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CifinService, deps: [{ token: 'urlApiCifin' }, { token: i1$3.HttpClient }, { token: RestHttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
CifinService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CifinService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CifinService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['urlApiCifin']
                }] }, { type: i1$3.HttpClient }, { type: RestHttpClientService }]; } });

class MessageAlertComponent {
    closeLockDetailsModal() {
        this.isOpenLockDetailsModal = false;
    }
    openLockDetailsModal() {
        this.isOpenLockDetailsModal = true;
    }
}
MessageAlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MessageAlertComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MessageAlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: MessageAlertComponent, selector: "app-message-alert", ngImport: i0, template: "<ng-template #locksInfo>\n  <ul class=\"lock__list mb-2 pl-3\">\n    <li>\n      La primera vez bloqueo de\n      <span class=\"font-weight-bold\"> 1 d\u00EDa.</span>\n    </li>\n    <li>\n      La segunda vez bloqueo de\n      <span class=\"font-weight-bold\"> 1 semana.</span>\n    </li>\n    <li>\n      La tercera vez bloqueo de\n      <span class=\"font-weight-bold\"> 1 mes.</span>\n    </li>\n  </ul>\n  <p class=\"mb-0\">\n    El bloqueo aplica para esta y otras plataformas que usan Cifin como medio de\n    validaci\u00F3n.\n  </p>\n</ng-template>\n\n<div class=\"message_alert row m-1\">\n  <div class=\"col-md-2 text-center\">\n    <i class=\"far fa-2x fa-info-circle message_alert__icon\"></i>\n  </div>\n  <div class=\"col-md-8\">\n    Si respondes incorrectamente a las preguntas, puedes recibir un\n    <span class=\"font-weight-bold\">bloqueo temporal.</span>\n  </div>\n  <div class=\"col-md-2 d-md-block d-none\">\n    <a class=\"details__button\" placement=\"bottom\" [ngbPopover]=\"locksInfo\"\n      >Ver detalles\n    </a>\n  </div>\n  <div class=\"col-md-4 d-block d-md-none\">\n    <a class=\"details__button\" (click)=\"openLockDetailsModal()\">\n      Ver detalles\n    </a>\n    <sura-modal\n      [isopen]=\"isOpenLockDetailsModal\"\n      [hasfooter]=\"true\"\n      (close)=\"closeLockDetailsModal()\"\n    >\n      <div slot=\"modaltitle\">\n        <h4>Detalle de bloqueos</h4>\n      </div>\n      <div slot=\"modalbody\">\n        <ng-container *ngTemplateOutlet=\"locksInfo\"></ng-container>\n      </div>\n      <div slot=\"modalfooter\" class=\"w-100 text-center\">\n        <button\n          type=\"button\"\n          id=\"id-button-cerrar-modal\"\n          class=\"modal__button w-50 rounded-pill py-2\"\n          (click)=\"closeLockDetailsModal()\"\n        >\n          Aceptar\n        </button>\n      </div>\n    </sura-modal>\n  </div>\n</div>\n", styles: [".message_alert{background-color:#fef9e7;padding:1rem}.message_alert__icon{color:#fca904}.lock__list{min-width:10rem}.details__button{color:var(--primary)!important;text-decoration:underline!important;cursor:pointer}.modal__button{background-color:var(--primary);color:var(--bg-color-button-primary);font-size:1rem;outline:none;font-weight:bold;text-transform:uppercase;border:0}.modal__button:hover{background-color:var(--hover-bg-color-button-primary);color:var(--hover-color-button-primary)}\n"], directives: [{ type: i1$2.NgbPopover, selector: "[ngbPopover]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disablePopover", "popoverClass", "openDelay", "closeDelay", "ngbPopover", "popoverTitle"], outputs: ["shown", "hidden"], exportAs: ["ngbPopover"] }, { type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MessageAlertComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-message-alert',
                    templateUrl: './message-alert.component.html',
                    styleUrls: ['./message-alert.component.scss'],
                }]
        }] });

class ValidacionComponent {
    constructor(formBuilder, cifinService, suraLoadingService) {
        this.formBuilder = formBuilder;
        this.cifinService = cifinService;
        this.suraLoadingService = suraLoadingService;
        this.mostrarMensajeBloqueo = false;
        this.checkboxDeclaracionAsegurabilidad = false;
        this.cifinError = new EventEmitter();
        this.validacionExitosa = new EventEmitter();
        this.isFormSubmitted = false;
    }
    get getQuestions() {
        return this.form.get('questions');
    }
    ngOnInit() {
        this.getCifin();
    }
    buildForm() {
        if (this.checkboxDeclaracionAsegurabilidad) {
            this.form = this.formBuilder.group({
                questions: this.formBuilder.array([]),
                declaracionAsegurabilidad: [false, Validators.requiredTrue],
            });
        }
        else {
            this.form = this.formBuilder.group({
                questions: this.formBuilder.array([]),
            });
        }
        this.answerDataField.jsonValue.questions.forEach((question, index) => {
            this.getQuestions.push(this.formBuilder.group({
                [question.id]: [null, [Validators.required]],
            }));
        });
    }
    submit() {
        this.form.updateValueAndValidity();
        this.isFormSubmitted = true;
        if (this.form.valid) {
            let question;
            this.getQuestions.value.forEach((questionForm, index) => {
                question = this.answerDataField.jsonValue.questions[index];
                question.answer.forEach((respuesta, indexRespuesta) => {
                    if (Number(questionForm[question.id]) === indexRespuesta) {
                        respuesta.isSelected = 'true';
                    }
                    else {
                        respuesta.isSelected = 'false';
                    }
                });
            });
            this.responderCifin();
        }
    }
    /**
     * Metodo que va por la preguntas cifin, a partir del  25/06/2019 se tiene como servicio
     * principal el de transunion pero como acción de contingencia también se tendrá la mediacion
     * SURA solo cuando falle el primero antes mencionado.
     * El primerApellido : Para TU es requerido a partir del 25/06/2019 ya que se hace el consumo
     * contra transunion
     *
     * 01/04/2020:
     * Si el servicio de transunion falla, llega la respuesta del servicio mediador,
     * esta respuesta está acoplada a arrendamientos por lo que no es una solución genérica.
     * Queda pendiente el tratamiento de esto desde el back
     */
    getCifin() {
        this.suraLoadingService.addLoadingTag(CifinLoadingTags.CARGANDO_PREGUNTAS);
        this.cifinService
            .getCifin(this.usuario.tipoDocumento, this.usuario.numeroDocumento, this.usuario.primerApellido)
            .subscribe((resp) => {
            if (resp != null) {
                if (resp.origin === OriginCifinResponse.TRANSUNION ||
                    resp.origin === OriginCifinResponse.TEST) {
                    this.origin = resp.origin;
                    this.validateTransUnionResponse(resp.dcResponse.responseInfo, resp.dcResponse.contextData);
                }
                else {
                    /**
                     * Si no llegan de transunion llegan del servicio de SURA el cual
                     * está acoplado a arrendamientos. Queda pendiente este tratamiento
                     * desde el back
                     */
                    this.errorMessage = CifinErrors.USUARIO_NO_REGISTRADO;
                    this.cifinError.emit({
                        type: CifinErrors.OBTENIENDO_PREGUNTAS,
                        message: CifinErrors.USUARIO_NO_REGISTRADO,
                    });
                }
            }
            else {
                this.errorMessage = CifinErrors.NO_EXISTEN_PREGUNTAS;
                this.cifinError.emit({
                    type: CifinErrors.OBTENIENDO_PREGUNTAS,
                    message: CifinErrors.NO_EXISTEN_PREGUNTAS,
                });
            }
            this.suraLoadingService.removeLoadingTag(CifinLoadingTags.CARGANDO_PREGUNTAS);
        }, error => {
            this.suraLoadingService.removeLoadingTag(CifinLoadingTags.CARGANDO_PREGUNTAS);
            this.errorMessage = CifinErrors.INTERNAL_BAD_GETWAY;
            this.cifinError.emit({
                type: CifinErrors.OBTENIENDO_PREGUNTAS,
                message: error.status,
            });
        });
    }
    closeModal() {
        this.errorMessage = undefined;
    }
    validateTransUnionResponse(responseInf, fieldList) {
        const currentQueue = responseInf.currentQueue;
        if (currentQueue === CifinResponses.CUSTIONARIO_VALIDO) {
            this.responseInf = responseInf;
            this.fieldList = fieldList;
            this.examDataField = this.fieldList.find(x => x.key === CifinFieldKey.EXAM_DATA);
            this.answerDataField = JSON.parse(JSON.stringify(this.examDataField));
            this.answerDataField.key = CifinFieldKey.ANSWER_DATA;
            this.buildForm();
        }
        else if (currentQueue === CifinResponses.CUESTIONARIO_BLOQUEADO) {
            this.errorMessage = CifinErrors.TU_BLOQUEADO;
            this.cifinError.emit({
                type: CifinErrors.OBTENIENDO_PREGUNTAS,
                message: CifinErrors.TU_BLOQUEADO,
            });
        }
        else {
            this.errorMessage = CifinErrors.NO_EXISTEN_PREGUNTAS;
            this.cifinError.emit({
                type: CifinErrors.OBTENIENDO_PREGUNTAS,
                message: CifinErrors.NO_EXISTEN_PREGUNTAS,
            });
        }
    }
    responderCifin() {
        const reqInfo = {
            applicationId: this.responseInf.applicationId,
            queueName: this.responseInf.currentQueue,
            executionMode: 'Send',
        };
        const listaRespuestas = new Array(this.answerDataField);
        const fullrequest = {
            origin: this.origin,
            requestInfo: reqInfo,
            fields: listaRespuestas,
        };
        this.suraLoadingService.addLoadingTag(CifinLoadingTags.GUARDANDO_RESPUESTAS);
        this.cifinService.respuestasCifin(fullrequest).subscribe((validacionExitosaCifin) => {
            if (validacionExitosaCifin.decision ===
                CifinResponses.RESPUESTAS_ERRONEAS ||
                validacionExitosaCifin.decision ===
                    CifinResponses.NO_EXISTE_CUESTIONARIO_EN_COLA) {
                this.errorMessage = CifinErrors.ERROR_EN_INTENTO;
                this.cifinError.emit({
                    type: CifinErrors.ERROR_EN_INTENTO,
                    message: CifinErrors.ERROR_EN_INTENTO,
                });
            }
            else {
                this.validacionExitosa.emit(validacionExitosaCifin);
            }
            this.suraLoadingService.removeLoadingTag(CifinLoadingTags.GUARDANDO_RESPUESTAS);
        }, error => {
            this.suraLoadingService.removeLoadingTag(CifinLoadingTags.GUARDANDO_RESPUESTAS);
            this.cifinError.emit({
                type: CifinErrors.ERROR_EN_INTENTO,
                message: error.status,
            });
        });
    }
}
ValidacionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ValidacionComponent, deps: [{ token: i3.FormBuilder }, { token: CifinService }, { token: i1.SuraLoadingService }], target: i0.ɵɵFactoryTarget.Component });
ValidacionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ValidacionComponent, selector: "app-validacion", inputs: { usuario: "usuario", mostrarMensajeBloqueo: "mostrarMensajeBloqueo", checkboxDeclaracionAsegurabilidad: "checkboxDeclaracionAsegurabilidad" }, outputs: { cifinError: "cifinError", validacionExitosa: "validacionExitosa" }, ngImport: i0, template: "<ng-content select=\"[slot=header]\"></ng-content>\n<app-message-alert *ngIf=\"mostrarMensajeBloqueo\"></app-message-alert>\n<form\n  *ngIf=\"form !== undefined\"\n  [formGroup]=\"form\"\n  class=\"col-12 col-sm-10 col-md-8 col-xl-7 mx-auto pb-3 px-0\"\n  ngNativeValidate\n>\n  <app-question\n    [isFormSubmitted]=\"isFormSubmitted\"\n    formArrayName=\"questions\"\n    *ngFor=\"let item of getQuestions.controls; let i = index\"\n    [pregunta]=\"this.answerDataField.jsonValue.questions[i]\"\n    [myform]=\"item\"\n    [indexPregunta]=\"i\"\n  ></app-question>\n  <div\n    *ngIf=\"checkboxDeclaracionAsegurabilidad\"\n    class=\"font-weight-light pb-4 text-center\"\n  >\n    <label class=\"form-check-label\">\n      <input\n        class=\"form-check-input\"\n        type=\"checkbox\"\n        formControlName=\"declaracionAsegurabilidad\"\n        id=\"id-declaracion-asegurabilidad\"\n      />\n      <small>Declaraci\u00F3n de asegurabilidad</small>\n    </label>\n  </div>\n  <div class=\"col-12 text-center\">\n    <ng-content select=\"[slot=button]\"></ng-content>\n  </div>\n</form>\n", styles: [".continue-btn{padding:0 30px;background:var(--primary) 0% 0% no-repeat padding-box;box-shadow:0 3px 6px #00000029;height:40px;border-radius:20px;font-family:\"FSJoeySemiBold\";font-weight:bold;text-align:center;font-size:15px;color:#fff;opacity:1}\n"], components: [{ type: MessageAlertComponent, selector: "app-message-alert" }, { type: QuestionComponent, selector: "app-question", inputs: ["pregunta", "myform", "isFormSubmitted", "indexPregunta"] }], directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { type: i3.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ValidacionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-validacion',
                    templateUrl: './validacion.component.html',
                    styleUrls: ['./validacion.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i3.FormBuilder }, { type: CifinService }, { type: i1.SuraLoadingService }]; }, propDecorators: { usuario: [{
                type: Input
            }], mostrarMensajeBloqueo: [{
                type: Input
            }], checkboxDeclaracionAsegurabilidad: [{
                type: Input
            }], cifinError: [{
                type: Output
            }], validacionExitosa: [{
                type: Output
            }] } });

class CifinModule {
}
CifinModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CifinModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CifinModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CifinModule, declarations: [QuestionComponent, ValidacionComponent, MessageAlertComponent], imports: [CommonModule, ReactiveFormsModule, ErrorManage, NgbModule], exports: [QuestionComponent, ValidacionComponent, MessageAlertComponent] });
CifinModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CifinModule, imports: [[CommonModule, ReactiveFormsModule, ErrorManage, NgbModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CifinModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [QuestionComponent, ValidacionComponent, MessageAlertComponent],
                    imports: [CommonModule, ReactiveFormsModule, ErrorManage, NgbModule],
                    exports: [QuestionComponent, ValidacionComponent, MessageAlertComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

var TipoDeDocumentoCifin;
(function (TipoDeDocumentoCifin) {
    TipoDeDocumentoCifin["CEDULA"] = "C";
    TipoDeDocumentoCifin["CEDULA_EXTRANJERIA"] = "E";
})(TipoDeDocumentoCifin || (TipoDeDocumentoCifin = {}));

class TokenService {
    constructor(apiBaseRenting, restHttpClientService) {
        this.apiBaseRenting = apiBaseRenting;
        this.restHttpClientService = restHttpClientService;
    }
    getToken(email) {
        return this.restHttpClientService.post({
            email,
        }, `${this.apiBaseRenting}${TokenService.GET_TOKEN_ENDPOINT}`, HEADER_NO_SECURE);
    }
}
TokenService.GET_TOKEN_ENDPOINT = `/token/gettoken`;
TokenService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TokenService, deps: [{ token: 'urlApiRenting' }, { token: RestHttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
TokenService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TokenService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TokenService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['urlApiRenting']
                }] }, { type: RestHttpClientService }]; } });

var ModalTypes;
(function (ModalTypes) {
    ModalTypes["MESSAGE_WITH_CONFIRMATION"] = "messageWithConfirmation";
    ModalTypes["MESSAGE"] = "message";
    ModalTypes["CONFIRMATION"] = "confirmation";
})(ModalTypes || (ModalTypes = {}));

var ModalButtonLabels;
(function (ModalButtonLabels) {
    ModalButtonLabels["SI"] = "Si";
    ModalButtonLabels["NO"] = "No";
    ModalButtonLabels["OK"] = "Ok";
})(ModalButtonLabels || (ModalButtonLabels = {}));

class ConfirmationModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    callConfirmation(title, message, yesLabel = ModalButtonLabels.SI, noLabel = ModalButtonLabels.NO, buttonOkHtml, buttonCancelHtml) {
        const modalRef = this.modalService.open(ConfirmationModalComponent);
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.noLabel = noLabel;
        modalRef.componentInstance.yesLabel = yesLabel;
        modalRef.componentInstance.typeModal = ModalTypes.CONFIRMATION;
        modalRef.componentInstance.buttonOkTemplate = buttonOkHtml;
        modalRef.componentInstance.buttonCancelTemplate = buttonCancelHtml;
        return modalRef.result;
    }
    callMessage(title, message, okLabel = ModalButtonLabels.OK, buttonHtml) {
        const modalRef = this.modalService.open(ConfirmationModalComponent);
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.yesLabel = okLabel;
        modalRef.componentInstance.typeModal = ModalTypes.MESSAGE;
        modalRef.componentInstance.buttonOkTemplate = buttonHtml;
        return modalRef.result;
    }
    callConfirmationWithTemplateRef(title, HTMLmessage, yesLabel = ModalButtonLabels.SI, noLabel = ModalButtonLabels.NO, buttonOkHtml, buttonCancelHtml) {
        const modalRef = this.modalService.open(ConfirmationModalComponent);
        modalRef.componentInstance.message = HTMLmessage;
        modalRef.componentInstance.html = true;
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.noLabel = noLabel;
        modalRef.componentInstance.yesLabel = yesLabel;
        modalRef.componentInstance.typeModal = ModalTypes.CONFIRMATION;
        modalRef.componentInstance.buttonOkTemplate = buttonOkHtml;
        modalRef.componentInstance.buttonCancelTemplate = buttonCancelHtml;
        return modalRef.result;
    }
    callMessageWithTemplateRef(title, HTMLmessage, okLabel = ModalButtonLabels.OK, modalSize, buttonHtml) {
        const modalRef = this.modalService.open(ConfirmationModalComponent, {
            windowClass: modalSize,
        });
        modalRef.componentInstance.message = HTMLmessage;
        modalRef.componentInstance.html = true;
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.yesLabel = okLabel;
        modalRef.componentInstance.typeModal = ModalTypes.MESSAGE;
        modalRef.componentInstance.buttonOkTemplate = buttonHtml;
        return modalRef.result;
    }
    callMessageWithConfirmation(title, message, okLabel = ModalButtonLabels.OK, minHeight, buttonHtml) {
        const modalRef = this.modalService.open(ConfirmationModalComponent, {
            windowClass: minHeight,
        });
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.yesLabel = okLabel;
        modalRef.componentInstance.typeModal = ModalTypes.MESSAGE_WITH_CONFIRMATION;
        modalRef.componentInstance.buttonOkTemplate = buttonHtml;
        return modalRef.result;
    }
    callMessageWithConfirmationTemplateRef(title, HTMLmessage, okLabel = ModalButtonLabels.OK, minHeight, buttonHtml) {
        const modalRef = this.modalService.open(ConfirmationModalComponent, {
            windowClass: minHeight,
        });
        modalRef.componentInstance.message = HTMLmessage;
        modalRef.componentInstance.html = true;
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.yesLabel = okLabel;
        modalRef.componentInstance.typeModal = ModalTypes.MESSAGE_WITH_CONFIRMATION;
        modalRef.componentInstance.buttonOkTemplate = buttonHtml;
        return modalRef.result;
    }
}
ConfirmationModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfirmationModalService, deps: [{ token: i1$2.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
ConfirmationModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfirmationModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfirmationModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }]; } });

class RecaptchaChallengeService {
    constructor() {
        this.challengeComplete$ = new Subject();
        this.challengeStart$ = new Subject();
    }
    startingChallenge(callback) {
        if (callback)
            callback();
        this.challengeStart$.next();
    }
    isErrorScore(err) {
        var _a, _b, _c;
        const { status, error } = err;
        return (status === 400 &&
            (((_b = (_a = error === null || error === void 0 ? void 0 : error.respuesta) === null || _a === void 0 ? void 0 : _a.at(0)) === null || _b === void 0 ? void 0 : _b.requestId) === 'Validacion de Token Captcha' ||
                ((_c = error === null || error === void 0 ? void 0 : error.respuesta) === null || _c === void 0 ? void 0 : _c.requestId) === 'Validacion de Token Captcha'));
    }
}
RecaptchaChallengeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaChallengeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
RecaptchaChallengeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaChallengeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaChallengeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class RecaptchaChallengeComponent {
    constructor(ngbModal, recaptchaChallengeService) {
        this.ngbModal = ngbModal;
        this.recaptchaChallengeService = recaptchaChallengeService;
        this.googlereCAPTCHAKey = '';
    }
    ngOnInit() {
        this.recaptchaChallengeService.challengeStart$.subscribe(() => {
            this.openModal();
        });
    }
    resolved(captchaResponse) {
        this.recaptchaChallengeService.challengeComplete$.next(captchaResponse);
        this.cerrarModal();
    }
    openModal() {
        this.modalDeError = this.ngbModal.open(this.templateDeModalDeError, {
            centered: true,
            size: 'md',
            backdrop: 'static',
        });
    }
    cerrarModal() {
        this.ngbModal.dismissAll();
    }
}
RecaptchaChallengeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaChallengeComponent, deps: [{ token: i1$2.NgbModal }, { token: RecaptchaChallengeService }], target: i0.ɵɵFactoryTarget.Component });
RecaptchaChallengeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: RecaptchaChallengeComponent, selector: "recaptcha-challenge", inputs: { googlereCAPTCHAKey: "googlereCAPTCHAKey" }, viewQueries: [{ propertyName: "templateDeModalDeError", first: true, predicate: ["modalDeError"], descendants: true }], ngImport: i0, template: "<ng-template #modalDeError>\n  <lib-sura-modal class=\"modal-go-back\" alignBody=\"center\" disableClose=\"true\">\n    <ng-container slot=\"body\">\n      <div class=\"col\">\n        <div class=\"text-center header\">\n          <div class=\"col-12 pb-3\">\n            <i class=\"far fa-exclamation-circle fa-4x d-block header__icon\"></i>\n          </div>\n        </div>\n        <div class=\"text-center\">\n          <p class=\"error-descripcion\">\n            Para continuar, por favor, completa el siguiente captcha.\n          </p>\n        </div>\n        <div class=\"captcha-container\" id=\"recaptchaID\">\n          <re-captcha\n            #recaptcha\n            (resolved)=\"resolved($event)\"\n            [siteKey]=\"googlereCAPTCHAKey\"\n          ></re-captcha>\n        </div>\n      </div>\n    </ng-container>\n  </lib-sura-modal>\n</ng-template>\n", styles: [".modal-error{font-family:var(--font-family-secondary)}.header__icon{color:var(--color-title-modal-error, #ff9a41)}.header__title{color:var(--color-title-modal-error, #ff9a41);font-weight:700;font-size:2rem}.error-descripcion{font-size:1rem}.captcha-container{display:flex;justify-content:center}\n"], components: [{ type: i3$1.LibSuraModalComponent, selector: "lib-sura-modal", inputs: ["alignHeader", "defaultButtonText", "alignBody", "disableClose", "type"], outputs: ["handleSubmit"] }, { type: i4.RecaptchaComponent, selector: "re-captcha", inputs: ["id", "errorMode", "siteKey", "theme", "type", "size", "badge", "tabIndex"], outputs: ["resolved", "error"], exportAs: ["reCaptcha"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaChallengeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'recaptcha-challenge',
                    templateUrl: './recaptcha-challenge.component.html',
                    styleUrls: ['./recaptcha-challenge.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }, { type: RecaptchaChallengeService }]; }, propDecorators: { googlereCAPTCHAKey: [{
                type: Input
            }], templateDeModalDeError: [{
                type: ViewChild,
                args: ['modalDeError']
            }] } });

class RecaptchaChallengeModule {
}
RecaptchaChallengeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaChallengeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RecaptchaChallengeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaChallengeModule, declarations: [RecaptchaChallengeComponent], imports: [CommonModule, SuraModalModule, RecaptchaModule], exports: [RecaptchaChallengeComponent] });
RecaptchaChallengeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaChallengeModule, imports: [[CommonModule, SuraModalModule, RecaptchaModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaChallengeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RecaptchaChallengeComponent],
                    imports: [CommonModule, SuraModalModule, RecaptchaModule],
                    exports: [RecaptchaChallengeComponent],
                }]
        }] });

/*
 * Public API Surface of common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AsesorComponent, AsesoresComponent, ChatbotTibotComponent, CifinErrors, CifinFieldKey, CifinLoadingTags, CifinModule, CifinResponses, CifinService, CommonComponentsModule, ConfirmationModalComponent, ConfirmationModalService, HEADER_NO_SECURE, MessageAlertComponent, ModalButtonLabels, ModalTypes, OriginCifinResponse, PaginaErrorComponent, PaginaNoEncontradaComponent, QuestionComponent, RecaptchaChallengeComponent, RecaptchaChallengeModule, RecaptchaChallengeService, RestHttpClientService, SuraButtonComponent, TipoDeDocumentoCifin, TokenService, ValidacionComponent, getSecureHeader };
